var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/hooks/use-get-traits-for-media.hook.ts
import { queryHelpers, useMediaQuery } from "@leagueplatform/genesis-core";
var useGetTraitsForMedia = (traits) => {
  const isMobile = useMediaQuery(queryHelpers.down("mobileLandscape"));
  const isTablet = useMediaQuery(
    queryHelpers.between(["mobileLandscape", "laptop"])
  );
  const isLaptop = useMediaQuery(queryHelpers.only("laptop"));
  const isDesktop = useMediaQuery(queryHelpers.up("desktop"));
  if (isMobile)
    return traits == null ? void 0 : traits.mobile;
  if (isTablet)
    return traits == null ? void 0 : traits.tablet;
  if (isLaptop)
    return traits == null ? void 0 : traits.laptop;
  if (isDesktop)
    return traits == null ? void 0 : traits.desktop;
  return {};
};

// src/components/masonry-small-card-renderer/masonry-small-card-renderer.component.tsx
import React7 from "react";
import {
  Box as Box2,
  HeadingText,
  ParagraphText,
  StackItem,
  StackLayout as StackLayout4,
  useClickableCard,
  UtilityText as UtilityText2
} from "@leagueplatform/genesis-core";
import {
  useMasonryEngineActionEmitter as useMasonryEngineActionEmitter2
} from "@leagueplatform/masonry-engine";

// src/utils/body-text-html-tag-options.ts
import { TextAction } from "@leagueplatform/genesis-core";
import { InternalOrExternalLinkButton } from "@leagueplatform/web-common-components";
var BodyTextHtmlTagOptions = {
  a: {
    component: InternalOrExternalLinkButton,
    props: {
      baseComponent: TextAction,
      // Stop event propagation to prevent triggering on card click event on click of link inside paragraph text
      onClick: (e) => e.stopPropagation()
    }
  }
};

// src/common/badge-list/badge-list.component.tsx
import * as React2 from "react";
import { UtilityText, StackLayout as StackLayout2, Icon } from "@leagueplatform/genesis-core";
import { uniqueId } from "lodash";

// src/common/badge-pill/badge-pill.component.tsx
import React from "react";
import { StackLayout } from "@leagueplatform/genesis-core";
var BadgePill = ({
  children,
  backgroundColor = "$decorativeBrandSecondaryBright"
}) => /* @__PURE__ */ React.createElement(
  StackLayout,
  {
    orientation: "horizontal",
    verticalAlignment: "center",
    spacing: "$quarter",
    css: {
      flex: "0 0 auto",
      borderStyle: "$solid",
      borderRadius: "$pill",
      paddingInline: "$half",
      paddingBlock: "$quarter",
      width: "fit-content",
      backgroundColor
    }
  },
  children
);

// src/common/badge-list/badge-list.component.tsx
var BadgeList = ({ badges, backgroundColor }) => /* @__PURE__ */ React2.createElement(
  StackLayout2,
  {
    orientation: "horizontal",
    verticalAlignment: "center",
    spacing: "$threeQuarters",
    css: {
      flexWrap: "wrap"
    }
  },
  badges == null ? void 0 : badges.map(
    ({
      image,
      imageAltText,
      body,
      backgroundColor: badgeBackgroundColor
    }) => /* @__PURE__ */ React2.createElement(
      BadgePill,
      {
        key: uniqueId(),
        backgroundColor: badgeBackgroundColor || backgroundColor
      },
      image && /* @__PURE__ */ React2.createElement(Icon, { icon: image, label: imageAltText, size: "$threeQuarters" }),
      body && /* @__PURE__ */ React2.createElement(
        UtilityText,
        {
          emphasis: "emphasized",
          size: "sm",
          css: {
            color: "$onSurfaceTextPrimary",
            textAlign: "center"
          }
        },
        body
      )
    )
  )
);

// src/common/square-image-container/square-image-container.component.tsx
import * as React3 from "react";
import { Box, styled } from "@leagueplatform/genesis-core";
var StyledImgContainer = styled(Box, {
  borderRadius: "medium",
  maxHeight: "$$maxImageWidth",
  maxWidth: "$$maxImageWidth",
  aspectRatio: "1 / 1",
  flex: 1,
  overflow: "hidden",
  "@tablet": {
    maxHeight: "$$maxWidthDesktop",
    maxWidth: "$$maxWidthDesktop"
  }
});
var StyledImg = styled("img", {
  width: "100%",
  height: "100%",
  objectFit: "cover"
});
var SquareImageContainer = ({
  src,
  maxWidth,
  maxWidthDesktop,
  alt
}) => /* @__PURE__ */ React3.createElement(
  StyledImgContainer,
  {
    css: { $$maxImageWidth: maxWidth, $$maxWidthDesktop: maxWidthDesktop }
  },
  /* @__PURE__ */ React3.createElement(StyledImg, { src, alt })
);

// src/components/common/conditional-link-card-renderer/conditional-link-card-renderer.component.tsx
import React5, { forwardRef } from "react";
import {
  Card,
  StackLayout as StackLayout3
} from "@leagueplatform/genesis-core";

// src/components/common/dismiss-button/dismiss-button.tsx
import React4 from "react";
import {
  Button,
  useThemeStrings
} from "@leagueplatform/genesis-core";
import { useMasonryEngineActionEmitter } from "@leagueplatform/masonry-engine";
var DismissButton = ({
  onDismiss,
  toolbarButton,
  css
}) => {
  const invokeAction = useMasonryEngineActionEmitter();
  const strings = useThemeStrings();
  return /* @__PURE__ */ React4.createElement(
    Button,
    __spreadProps(__spreadValues({
      className: "dismiss-button",
      hideLabel: true,
      size: toolbarButton ? "toolbar" : "medium",
      icon: "interfaceClose",
      priority: "tertiary",
      css
    }, !toolbarButton && { quiet: true }), {
      onClick: (event) => {
        if (onDismiss) {
          invokeAction(__spreadValues({
            event
          }, onDismiss));
        }
      }
    }),
    strings.dismiss
  );
};

// src/components/common/conditional-link-card-renderer/conditional-link-card-renderer.component.tsx
var ElevatedCardWithClickArea = forwardRef(
  ({
    css,
    children,
    onCardMouseUp,
    onCardMouseDown,
    imagePosition,
    onDismiss,
    toolbarButton,
    hasFloatingDismissButton
  }, ref) => /* @__PURE__ */ React5.createElement(
    Card.Elevated,
    {
      backgroundColor: "secondary",
      css: __spreadValues({
        "&:has(.GDS-card-click-area)": {
          border: "$borderWidths$card solid $onSurfaceBorderCard",
          boxShadow: "$card",
          borderRadius: "$card"
        },
        "&:hover:not(:has(.dismiss-button:hover))": {
          border: "$borderWidths$card solid $colors$interactiveFocusOuter"
        }
      }, css)
    },
    onDismiss && (hasFloatingDismissButton ? /* @__PURE__ */ React5.createElement(
      DismissButton,
      {
        onDismiss,
        toolbarButton,
        css: {
          position: "absolute",
          insetBlockStart: "$half",
          insetInlineEnd: "$half",
          zIndex: 2
        }
      }
    ) : /* @__PURE__ */ React5.createElement(
      StackLayout3,
      {
        horizontalAlignment: "end",
        css: { padding: "$half $oneAndHalf 0 0" }
      },
      /* @__PURE__ */ React5.createElement(
        DismissButton,
        {
          onDismiss,
          toolbarButton
        }
      )
    )),
    /* @__PURE__ */ React5.createElement(
      Card.ClickArea,
      {
        ref,
        onCardMouseUp,
        onCardMouseDown,
        imagePosition,
        "data-testid": "clickable-card",
        css: {
          border: "none",
          "&:hover": {
            border: "none"
          }
        }
      },
      children
    )
  )
);
var ElevatedCard = forwardRef(
  ({
    css,
    imagePosition,
    onDismiss,
    toolbarButton,
    children,
    hasFloatingDismissButton = false
  }, ref) => /* @__PURE__ */ React5.createElement(
    Card.Elevated,
    {
      ref,
      imagePosition,
      backgroundColor: "secondary",
      css
    },
    onDismiss && (hasFloatingDismissButton ? /* @__PURE__ */ React5.createElement(
      DismissButton,
      {
        onDismiss,
        toolbarButton,
        css: {
          position: "absolute",
          insetBlockStart: "$half",
          insetInlineEnd: "$half",
          zIndex: 2
        }
      }
    ) : /* @__PURE__ */ React5.createElement(
      StackLayout3,
      {
        horizontalAlignment: "end",
        css: { padding: "$half $oneAndHalf 0 0" }
      },
      /* @__PURE__ */ React5.createElement(
        DismissButton,
        {
          onDismiss,
          toolbarButton
        }
      )
    )),
    children
  )
);
var ConditionalLinkCardRenderer = forwardRef(
  ({
    css,
    children,
    hasLink,
    onCardMouseUp,
    onCardMouseDown,
    imagePosition,
    onDismiss,
    toolbarButton,
    hasFloatingDismissButton
  }, ref) => {
    const ConditionalLinkCard = hasLink ? ElevatedCardWithClickArea : ElevatedCard;
    return /* @__PURE__ */ React5.createElement(
      ConditionalLinkCard,
      {
        ref,
        onCardMouseUp,
        onCardMouseDown,
        css,
        imagePosition,
        onDismiss,
        toolbarButton,
        hasFloatingDismissButton
      },
      children
    );
  }
);

// src/components/common/conditional-link-renderer/conditional-link-renderer.component.tsx
import React6, { forwardRef as forwardRef2 } from "react";
import {
  TextAction as TextAction2,
  styled as styled2
} from "@leagueplatform/genesis-core";
import { normalizeInternalUrl } from "@leagueplatform/web-common";
import { InternalOrExternalLinkButton as InternalOrExternalLinkButton2 } from "@leagueplatform/web-common-components";
var StyledTextAction = styled2(TextAction2, {
  "&&": {
    all: "inherit",
    cursor: "pointer"
  }
});
var ConditionalLinkRenderer = forwardRef2(
  (_a, ref) => {
    var _b = _a, {
      children,
      url,
      onClick = () => {
      },
      css,
      disableDefaultOnClick
    } = _b, linkProps = __objRest(_b, [
      "children",
      "url",
      "onClick",
      "css",
      "disableDefaultOnClick"
    ]);
    const href = normalizeInternalUrl(url);
    if (url)
      return /* @__PURE__ */ React6.createElement(
        InternalOrExternalLinkButton2,
        __spreadValues({
          baseComponent: StyledTextAction,
          onClick: (e) => {
            e.stopPropagation();
            onClick(e);
          },
          ref,
          href,
          disableDefaultOnClick
        }, linkProps),
        children
      );
    return /* @__PURE__ */ React6.createElement("span", null, children);
  }
);

// src/components/masonry-small-card-renderer/masonry-small-card-renderer.component.tsx
var MasonrySmallCardRenderer = ({
  eyebrow,
  heading,
  body,
  image,
  badges,
  imageAltText = "",
  isChildItem = false,
  badgeBackgroundColor,
  onClick,
  onDismiss
}) => {
  const { primaryActionRef, clickAreaRef, onCardMouseDown, onCardMouseUp } = useClickableCard();
  const invokeAction = useMasonryEngineActionEmitter2();
  const overlineId = `svc-${heading == null ? void 0 : heading.replace(/\s+/g, "-")}`;
  const onClickDeeplinkAction = onClick;
  return /* @__PURE__ */ React7.createElement(
    ConditionalLinkCardRenderer,
    {
      hasLink: Boolean(onClickDeeplinkAction == null ? void 0 : onClickDeeplinkAction.payload.url),
      ref: clickAreaRef,
      onCardMouseUp,
      onCardMouseDown,
      onDismiss
    },
    /* @__PURE__ */ React7.createElement(
      StackLayout4,
      {
        orientation: {
          "@initial": "horizontal",
          "@mobile": "vertical",
          "@mobileLandscape": "horizontal"
        },
        verticalAlignment: "center",
        horizontalAlignment: "spaceBetween",
        spacing: "$threeQuarters",
        css: {
          padding: "$oneAndHalf"
        }
      },
      /* @__PURE__ */ React7.createElement(StackItem, { verticalAlignment: "center", css: { flex: "2" } }, /* @__PURE__ */ React7.createElement(StackItem, null, eyebrow && /* @__PURE__ */ React7.createElement(UtilityText2, { id: overlineId, size: "eyebrow", as: "p" }, eyebrow), /* @__PURE__ */ React7.createElement(StackLayout4, { css: { marginTop: "$quarter" } }, heading && /* @__PURE__ */ React7.createElement(
        HeadingText,
        {
          level: !body ? "display" : "3",
          size: "sm",
          "aria-describedby": overlineId
        },
        /* @__PURE__ */ React7.createElement(
          ConditionalLinkRenderer,
          {
            disableDefaultOnClick: true,
            ref: primaryActionRef,
            url: onClickDeeplinkAction == null ? void 0 : onClickDeeplinkAction.payload.url,
            onClick: (event) => {
              if (onClick) {
                invokeAction(__spreadValues({
                  event
                }, onClick));
              }
            }
          },
          heading
        )
      ), body && /* @__PURE__ */ React7.createElement(ParagraphText, { htmlStringOptions: BodyTextHtmlTagOptions }, body))), badges && /* @__PURE__ */ React7.createElement(Box2, { css: { marginTop: "$threeQuarters" } }, /* @__PURE__ */ React7.createElement(
        BadgeList,
        {
          badges,
          backgroundColor: badgeBackgroundColor
        }
      ))),
      image && /* @__PURE__ */ React7.createElement(StackItem, null, /* @__PURE__ */ React7.createElement(
        SquareImageContainer,
        {
          src: image,
          alt: imageAltText,
          maxWidth: "9.8rem",
          maxWidthDesktop: isChildItem ? "9.8rem" : "11.2rem"
        }
      ))
    )
  );
};

// src/components/masonry-extra-small-card-renderer/masonry-extra-small-card-renderer.component.tsx
import React8 from "react";
import {
  StackLayout as StackLayout5,
  StackItem as StackItem2,
  HeadingText as HeadingText2,
  ParagraphText as ParagraphText2,
  useClickableCard as useClickableCard2,
  Image,
  styled as styled3,
  Icon as Icon2
} from "@leagueplatform/genesis-core";
import {
  useMasonryEngineActionEmitter as useMasonryEngineActionEmitter3
} from "@leagueplatform/masonry-engine";

// src/utils/icon-mapping.ts
var ButtonIconTokenByString = {
  NEW_TAB_INTERNAL: "newTabInternal",
  NEW_WINDOW_INTERNAL: "newWindowInternal",
  EXTERNAL_LINK: "externalLink"
};
var TextActionIndicatorByString = {
  NEW_TAB_INTERNAL: "newTabInternal",
  EXTERNAL_LINK: "externalLink",
  DISCLOSURE: "disclosure"
};
var IconTokenByString = {
  NEW_WINDOW_INTERNAL: "interfaceChevronForward",
  EXTERNAL_LINK: "interfaceExternalLink",
  DISCLOSURE: "tinyDisclosureIndicator"
};
var labelByIndicator = {
  NEW_TAB_INTERNAL: "opens in a new tab",
  NEW_WINDOW_INTERNAL: "opens in a new window",
  EXTERNAL_LINK: "opens an external link",
  DISCLOSURE: "opens in a new tab"
};
var getButtonIconToken = (indicatorString) => ButtonIconTokenByString[indicatorString];
var getTextActionIndicatorIconToken = (indicatorString) => TextActionIndicatorByString[indicatorString];
var getIconToken = (indicatorString) => IconTokenByString[indicatorString];
var getLabelByIndicator = (indicator) => labelByIndicator[indicator];

// src/components/masonry-extra-small-card-renderer/masonry-extra-small-card-renderer.component.tsx
var StyledImage = styled3(Image, {
  contentFit: "cover",
  contentPosition: "center",
  width: "42px",
  height: "42px"
});
var MasonryExtraSmallCardRenderer = ({
  heading,
  headingLevel = "3",
  image,
  body,
  imageAltText = "",
  imageAlignment = "leading",
  actionIndicator,
  actionIndicatorLabel,
  onClick,
  onDismiss
}) => {
  const { primaryActionRef, clickAreaRef, onCardMouseDown, onCardMouseUp } = useClickableCard2();
  const invokeAction = useMasonryEngineActionEmitter3();
  return /* @__PURE__ */ React8.createElement(
    ConditionalLinkCardRenderer,
    {
      hasLink: Boolean(onClick == null ? void 0 : onClick.payload.url),
      ref: clickAreaRef,
      onCardMouseUp,
      onCardMouseDown,
      onDismiss
    },
    /* @__PURE__ */ React8.createElement(
      StackLayout5,
      {
        orientation: "horizontal",
        verticalAlignment: "center",
        spacing: image ? "$threeQuarters" : void 0,
        css: {
          padding: "$oneAndHalf"
        }
      },
      image && imageAlignment === "leading" && /* @__PURE__ */ React8.createElement(StackItem2, { verticalAlignment: "center" }, /* @__PURE__ */ React8.createElement(StyledImage, { src: image, alt: imageAltText })),
      /* @__PURE__ */ React8.createElement(StackLayout5, { css: { marginTop: "$quarter" }, verticalAlignment: "center" }, /* @__PURE__ */ React8.createElement(HeadingText2, { level: !body ? "display" : headingLevel, size: "sm" }, /* @__PURE__ */ React8.createElement(
        ConditionalLinkRenderer,
        {
          ref: primaryActionRef,
          disableDefaultOnClick: true,
          onClick: (event) => {
            if (onClick) {
              invokeAction(__spreadValues({
                event
              }, onClick));
            }
          },
          url: onClick == null ? void 0 : onClick.payload.url
        },
        heading
      )), body && /* @__PURE__ */ React8.createElement(ParagraphText2, { htmlStringOptions: BodyTextHtmlTagOptions }, body)),
      image && imageAlignment === "trailing" && /* @__PURE__ */ React8.createElement(StackItem2, { verticalAlignment: "center" }, /* @__PURE__ */ React8.createElement(StyledImage, { src: image, alt: imageAltText })),
      onClick && actionIndicator && /* @__PURE__ */ React8.createElement(StackItem2, { verticalAlignment: "center" }, /* @__PURE__ */ React8.createElement(
        Icon2,
        {
          icon: getIconToken(actionIndicator),
          label: actionIndicatorLabel || getLabelByIndicator(actionIndicator)
        }
      ))
    )
  );
};

// src/components/masonry-large-card-renderer/masonry-large-card-renderer.component.tsx
import React10 from "react";
import { Card as Card2, useClickableCard as useClickableCard3 } from "@leagueplatform/genesis-core";

// src/components/masonry-large-card-renderer/masonry-large-card-content-renderer.component.tsx
import React9 from "react";
import { uniqueId as uniqueId2 } from "lodash";
import {
  ParagraphText as ParagraphText3,
  StackLayout as StackLayout6,
  HeadingText as HeadingText3,
  UtilityText as UtilityText3,
  Box as Box3,
  TextAction as TextAction3
} from "@leagueplatform/genesis-core";
import { useMasonryEngineActionEmitter as useMasonryEngineActionEmitter4 } from "@leagueplatform/masonry-engine";
import { InternalOrExternalLinkButton as InternalOrExternalLinkButton3 } from "@leagueplatform/web-common-components";
var MasonryLargeCardContentRenderer = ({
  eyebrow,
  linkRefState,
  heading,
  body,
  badges,
  badgeBackgroundColor,
  onClick,
  ctaLabel,
  ctaIndicator: _ctaIndicator,
  isCtaLabelledByHeading
}) => {
  var _a;
  const eyebrowId = `lvc-${heading == null ? void 0 : heading.replace(/\s+/g, "-")}`;
  const headingId = React9.useMemo(
    () => uniqueId2("MasonryLargeCardContentRenderer"),
    []
  );
  const ctaId = `${headingId}-cta`;
  const ctaLabelledById = `${ctaId} ${headingId}`;
  const ctaIndicator = _ctaIndicator ? getTextActionIndicatorIconToken(_ctaIndicator) : void 0;
  const invokeAction = useMasonryEngineActionEmitter4();
  const handleOnClick = React9.useCallback(
    (event) => {
      if (onClick) {
        invokeAction(__spreadValues({
          event
        }, onClick));
      }
    },
    [invokeAction, onClick]
  );
  return /* @__PURE__ */ React9.createElement(StackLayout6, { spacing: "$half", orientation: "vertical" }, eyebrow && /* @__PURE__ */ React9.createElement(UtilityText3, { id: eyebrowId, size: "eyebrow", as: "p" }, eyebrow), /* @__PURE__ */ React9.createElement(StackLayout6, { spacing: "$oneAndHalf", orientation: "vertical" }, /* @__PURE__ */ React9.createElement(StackLayout6, { spacing: "$threeQuarters", orientation: "vertical" }, /* @__PURE__ */ React9.createElement(StackLayout6, { spacing: "$quarter", orientation: "vertical" }, heading && /* @__PURE__ */ React9.createElement(
    HeadingText3,
    {
      id: isCtaLabelledByHeading ? headingId : void 0,
      level: "3",
      size: "sm",
      "aria-describedby": eyebrowId
    },
    /* @__PURE__ */ React9.createElement(
      ConditionalLinkRenderer,
      {
        ref: linkRefState,
        url: ctaLabel ? void 0 : onClick == null ? void 0 : onClick.payload.url,
        disableDefaultOnClick: true,
        onClick: handleOnClick
      },
      heading
    )
  ), body && /* @__PURE__ */ React9.createElement(ParagraphText3, { htmlStringOptions: BodyTextHtmlTagOptions }, body)), badges && /* @__PURE__ */ React9.createElement(Box3, null, /* @__PURE__ */ React9.createElement(
    BadgeList,
    {
      badges,
      backgroundColor: badgeBackgroundColor
    }
  ))), ctaLabel && /* @__PURE__ */ React9.createElement(Box3, null, /* @__PURE__ */ React9.createElement(
    TextAction3,
    {
      as: InternalOrExternalLinkButton3,
      baseComponent: TextAction3,
      href: (_a = onClick == null ? void 0 : onClick.payload.url) != null ? _a : "",
      onClick: handleOnClick,
      id: isCtaLabelledByHeading ? ctaId : void 0,
      "aria-labelledby": isCtaLabelledByHeading ? ctaLabelledById : void 0,
      indicator: ctaIndicator,
      size: "medium"
    },
    ctaLabel
  ))));
};

// src/components/masonry-large-card-renderer/masonry-large-card-renderer.component.tsx
var MasonryLargeCardRenderer = (_a) => {
  var _b = _a, {
    isChildItem,
    image,
    imageAltText = "",
    onClick,
    showMobile,
    onDismiss,
    ctaIndicator,
    ctaLabel,
    isCtaLabelledByHeading
  } = _b, props = __objRest(_b, [
    "isChildItem",
    "image",
    "imageAltText",
    "onClick",
    "showMobile",
    "onDismiss",
    "ctaIndicator",
    "ctaLabel",
    "isCtaLabelledByHeading"
  ]);
  const { primaryActionRef, clickAreaRef, onCardMouseDown, onCardMouseUp } = useClickableCard3();
  const showSmallerCard = isChildItem || showMobile;
  const hasCta = Boolean(ctaLabel);
  const hasLink = Boolean(onClick == null ? void 0 : onClick.payload.url);
  const isConditionalLinkRendererEnabled = hasCta ? false : hasLink;
  return /* @__PURE__ */ React10.createElement(
    ConditionalLinkCardRenderer,
    {
      hasLink: isConditionalLinkRendererEnabled,
      ref: clickAreaRef,
      onCardMouseUp,
      onCardMouseDown,
      onDismiss,
      toolbarButton: true,
      hasFloatingDismissButton: true,
      imagePosition: showSmallerCard ? "top" : {
        "@initial": "end",
        "@mobile": "top"
      },
      css: {
        height: showSmallerCard ? "100%" : "auto"
      }
    },
    image && /* @__PURE__ */ React10.createElement(
      Card2.Image,
      {
        image,
        imageAlt: imageAltText,
        css: { "@mobile": { height: "176px" } }
      }
    ),
    /* @__PURE__ */ React10.createElement(Card2.Section, null, /* @__PURE__ */ React10.createElement(
      MasonryLargeCardContentRenderer,
      __spreadValues({
        linkRefState: primaryActionRef,
        onClick,
        ctaLabel,
        ctaIndicator,
        isCtaLabelledByHeading
      }, props)
    ))
  );
};

// src/components/masonry-cta-card-renderer/masonry-cta-card-renderer.component.tsx
import React11 from "react";
import {
  Button as Button2,
  Card as Card3,
  HeadingText as HeadingText4,
  ParagraphText as ParagraphText4,
  queryHelpers as queryHelpers2,
  StackItem as StackItem3,
  StackLayout as StackLayout7,
  useMediaQuery as useMediaQuery2,
  UtilityText as UtilityText4
} from "@leagueplatform/genesis-core";
import {
  useMasonryEngineActionEmitter as useMasonryEngineActionEmitter5
} from "@leagueplatform/masonry-engine";
import { InternalOrExternalLink } from "@leagueplatform/web-common-components";
var MasonryCTACardRenderer = ({
  body,
  buttonIndicator,
  buttonLabel,
  eyebrow,
  heading,
  image,
  imageAltText = "",
  isChildItem = false,
  onButtonClick,
  onDismiss,
  showMobile = false,
  rootElementRef
}) => {
  const isMobile = useMediaQuery2(queryHelpers2.only("mobile"));
  const showSmallerCard = isMobile || isChildItem || showMobile;
  const invokeAction = useMasonryEngineActionEmitter5();
  return /* @__PURE__ */ React11.createElement(
    Card3.Elevated,
    {
      css: {
        backgroundColor: "$surfaceBackgroundTertiary",
        padding: "$oneAndHalf"
      },
      ref: rootElementRef
    },
    onDismiss && /* @__PURE__ */ React11.createElement(StackItem3, { horizontalAlignment: "end" }, /* @__PURE__ */ React11.createElement(DismissButton, { onDismiss })),
    /* @__PURE__ */ React11.createElement(
      StackLayout7,
      {
        orientation: "horizontal",
        verticalAlignment: "center",
        spacing: {
          "@mobile": "$threeQuarters",
          "@initial": showSmallerCard ? "$threeQuarters" : "$oneAndHalf"
        }
      },
      /* @__PURE__ */ React11.createElement(StackLayout7, { orientation: "vertical", spacing: "$quarter" }, eyebrow && /* @__PURE__ */ React11.createElement(UtilityText4, { size: "eyebrow" }, eyebrow), /* @__PURE__ */ React11.createElement(HeadingText4, { level: "3", size: "sm" }, heading), /* @__PURE__ */ React11.createElement(ParagraphText4, { htmlStringOptions: BodyTextHtmlTagOptions }, body), !showSmallerCard && /* @__PURE__ */ React11.createElement(
        Button2,
        __spreadProps(__spreadValues({
          indicator: buttonIndicator ? getButtonIconToken(buttonIndicator) : void 0,
          css: { padding: "$half $two", marginTop: "$one" }
        }, (onButtonClick == null ? void 0 : onButtonClick.payload.url) && {
          as: InternalOrExternalLink,
          disableDefaultOnClick: true
        }), {
          href: onButtonClick == null ? void 0 : onButtonClick.payload.url,
          onClick: (event) => {
            if (onButtonClick) {
              invokeAction(__spreadValues({
                event
              }, onButtonClick));
            }
          }
        }),
        buttonLabel
      )),
      image && /* @__PURE__ */ React11.createElement(
        SquareImageContainer,
        {
          src: image,
          alt: imageAltText,
          maxWidth: "8rem",
          maxWidthDesktop: isChildItem ? "8rem" : "11.2rem"
        }
      )
    ),
    showSmallerCard && /* @__PURE__ */ React11.createElement(
      Button2,
      __spreadProps(__spreadValues({
        width: "fillContainer",
        indicator: buttonIndicator ? getButtonIconToken(buttonIndicator) : void 0,
        css: { padding: "$half $two", marginTop: "$one" }
      }, (onButtonClick == null ? void 0 : onButtonClick.payload.url) && {
        as: InternalOrExternalLink,
        disableDefaultOnClick: true
      }), {
        href: onButtonClick == null ? void 0 : onButtonClick.payload.url,
        onClick: (event) => {
          if (onButtonClick) {
            invokeAction(__spreadValues({
              event
            }, onButtonClick));
          }
        }
      }),
      buttonLabel
    )
  );
};

// src/components/masonry-divider-renderer/masonry-divider-renderer.component.tsx
import React12 from "react";
import {
  colorTokenMap,
  Divider,
  borderWidthTokenMap
} from "@leagueplatform/genesis-core";
var MasonryDividerRenderer = ({
  orientation,
  color = "onSurfaceBorderSubdued",
  thickness = "thin"
}) => {
  var _a, _b;
  const borderColor = (_a = colorTokenMap[color]) != null ? _a : color;
  const borderWidth = (_b = borderWidthTokenMap[thickness]) != null ? _b : thickness;
  return /* @__PURE__ */ React12.createElement(Divider, { orientation, css: { borderColor, borderWidth } });
};

// src/components/masonry-hero-banner-renderer/masonry-hero-banner-renderer.component.tsx
import React13, { useRef, useState, useEffect, useLayoutEffect } from "react";
import {
  Button as Button3,
  HeadingText as HeadingText5,
  ParagraphText as ParagraphText5,
  StackItem as StackItem4,
  StackLayout as StackLayout8,
  UtilityText as UtilityText5,
  VisuallyHidden,
  queryHelpers as queryHelpers3,
  useMediaQuery as useMediaQuery3,
  styled as styled4,
  Image as Image2
} from "@leagueplatform/genesis-core";
import {
  useMasonryEngineActionEmitter as useMasonryEngineActionEmitter6
} from "@leagueplatform/masonry-engine";
import { InternalOrExternalLink as InternalOrExternalLink2 } from "@leagueplatform/web-common-components";
import { PageHeaderBackground } from "@leagueplatform/masonry-widgets";
var DecorativeIcon = styled4(Image2, {
  width: "100%",
  height: "100%",
  objectFit: "cover"
});
var MasonryHeroBannerRenderer = ({
  heading,
  body,
  eyebrow,
  buttonLabel,
  buttonIcon,
  image,
  imageAltText = "",
  icon,
  curved,
  includeSafeArea = false,
  onButtonClick
}) => {
  const contentRef = useRef(null);
  const [contentHeight, setContentHeight] = useState(150);
  const isLaptopDown = useMediaQuery3(queryHelpers3.down("laptop"));
  const pageHeaderBackgroundHeightPadding = isLaptopDown ? 60 : 112;
  const invokeAction = useMasonryEngineActionEmitter6();
  useLayoutEffect(() => {
    const reportWindowSize = () => {
      var _a, _b;
      setContentHeight((_b = (_a = contentRef == null ? void 0 : contentRef.current) == null ? void 0 : _a.clientHeight) != null ? _b : contentHeight);
    };
    if (contentHeight !== void 0)
      window.addEventListener("resize", reportWindowSize);
    return () => window.removeEventListener("resize", reportWindowSize);
  }, [contentHeight]);
  useEffect(() => {
    var _a;
    if ((_a = contentRef == null ? void 0 : contentRef.current) == null ? void 0 : _a.clientHeight)
      setContentHeight(contentRef.current.clientHeight);
  }, []);
  return /* @__PURE__ */ React13.createElement(
    PageHeaderBackground,
    {
      height: `${contentHeight + pageHeaderBackgroundHeightPadding / 2}px`,
      pageHeaderBackgroundHeight: `${contentHeight + pageHeaderBackgroundHeightPadding}px`,
      backgroundImage: image,
      curved,
      imageAltText
    },
    /* @__PURE__ */ React13.createElement(
      StackLayout8,
      {
        orientation: "horizontal",
        spacing: "$one",
        horizontalAlignment: "start",
        verticalAlignment: "top",
        css: { position: "relative" }
      },
      /* @__PURE__ */ React13.createElement(
        StackItem4,
        {
          horizontalAlignment: "start",
          css: {
            marginInlineEnd: includeSafeArea ? "160px" : "none"
          },
          verticalAlignment: "top",
          ref: contentRef
        },
        /* @__PURE__ */ React13.createElement(
          StackLayout8,
          {
            orientation: "horizontal",
            spacing: "$oneAndHalf",
            horizontalAlignment: "start",
            verticalAlignment: "top"
          },
          icon && /* @__PURE__ */ React13.createElement(
            StackItem4,
            {
              css: {
                flex: "1 1 100%",
                overflow: "hidden",
                aspectRatio: "1 / 1",
                maxWidth: "64px",
                "@mobile": {
                  order: 2
                },
                "@laptop": {
                  maxWidth: "80px"
                },
                "@desktop": {
                  maxWidth: "96px"
                }
              }
            },
            /* @__PURE__ */ React13.createElement(DecorativeIcon, { src: icon, alt: "", "data-testid": "hero-icon" })
          ),
          /* @__PURE__ */ React13.createElement(StackItem4, { horizontalAlignment: "start", verticalAlignment: "top" }, eyebrow && /* @__PURE__ */ React13.createElement(UtilityText5, { size: "eyebrow" }, eyebrow), heading && /* @__PURE__ */ React13.createElement(
            HeadingText5,
            {
              level: "1",
              size: {
                "@initial": "xl",
                "@laptop": "xxl",
                "@desktop": "xxl"
              },
              css: {
                marginTop: "$quarter"
              }
            },
            heading
          ), body && /* @__PURE__ */ React13.createElement(
            ParagraphText5,
            {
              htmlStringOptions: BodyTextHtmlTagOptions,
              css: {
                typography: "$bodyTwo",
                marginTop: "$threeQuarters",
                color: "$onSurfaceTextPrimary",
                "@laptop": {
                  typography: "$bodyOne"
                },
                "@desktop": {
                  typography: "$bodyOne"
                }
              }
            },
            body
          ), buttonLabel && /* @__PURE__ */ React13.createElement(
            Button3,
            __spreadProps(__spreadValues({
              size: "medium",
              priority: "primary",
              icon: buttonIcon,
              css: {
                marginTop: "$one"
              }
            }, (onButtonClick == null ? void 0 : onButtonClick.payload.url) && {
              as: InternalOrExternalLink2,
              disableDefaultOnClick: true
            }), {
              href: onButtonClick == null ? void 0 : onButtonClick.payload.url,
              onClick: (event) => {
                if (onButtonClick) {
                  invokeAction(__spreadValues({
                    event
                  }, onButtonClick));
                }
              }
            }),
            buttonLabel
          ), image && /* @__PURE__ */ React13.createElement(
            VisuallyHidden,
            {
              "data-testid": "hero-img",
              role: "img",
              "aria-label": imageAltText
            }
          ))
        )
      )
    )
  );
};

// src/components/masonry-section-header-renderer/masonry-section-header-renderer.component.tsx
import * as React15 from "react";
import { SectionHeader } from "@leagueplatform/genesis-core-alpha";

// src/components/common/masonry-text-action/masonry-text-action.component.tsx
import React14, { useMemo, useCallback } from "react";
import {
  TextAction as TextAction4
} from "@leagueplatform/genesis-core";
import { useMasonryEngineActionEmitter as useMasonryEngineActionEmitter7 } from "@leagueplatform/masonry-engine";
import { InternalOrExternalLink as Link } from "@leagueplatform/web-common-components";
var MasonryTextAction = (_a) => {
  var _b = _a, {
    icon,
    indicator,
    onClick,
    size,
    text,
    variant = "default"
  } = _b, props = __objRest(_b, [
    "icon",
    "indicator",
    "onClick",
    "size",
    "text",
    "variant"
  ]);
  var _a2;
  const invokeAction = useMasonryEngineActionEmitter7();
  const isTextActionLink = (onClick == null ? void 0 : onClick.type) === "deeplink" && Boolean((_a2 = onClick == null ? void 0 : onClick.payload) == null ? void 0 : _a2.url);
  const handleOnClick = useCallback(
    (event) => {
      if (onClick) {
        invokeAction(__spreadValues({
          event
        }, onClick));
      }
    },
    [invokeAction, onClick]
  );
  const textActionLinkUrl = useMemo(
    () => {
      var _a3;
      return isTextActionLink ? (_a3 = onClick == null ? void 0 : onClick.payload) == null ? void 0 : _a3.url : void 0;
    },
    [isTextActionLink, onClick]
  );
  const variantProps = useMemo(() => {
    switch (variant) {
      case "default":
        return { emphasis: "base" };
      case "subtle":
        return { emphasis: "subtle" };
      case "destructive":
        return { destructive: true };
      default:
        return void 0;
    }
  }, [variant]);
  return /* @__PURE__ */ React14.createElement(
    TextAction4,
    __spreadValues(__spreadValues(__spreadProps(__spreadValues({
      as: isTextActionLink ? Link : "button"
    }, textActionLinkUrl && {
      href: textActionLinkUrl
    }), {
      icon,
      indicator,
      onClick: handleOnClick,
      size
    }), variantProps), props),
    text
  );
};
MasonryTextAction.displayName = "MasonryTextAction";

// src/components/masonry-section-header-renderer/masonry-section-header-renderer.component.tsx
var MasonrySectionHeaderRenderer = ({
  heading,
  headingLevel,
  buttonLabel,
  subtitle,
  onButtonClicked: onClick,
  isCtaLabelledByHeading,
  paddingTop = "$one"
}) => {
  const hasTextAction = !!onClick && !!buttonLabel;
  return /* @__PURE__ */ React15.createElement(
    SectionHeader,
    {
      css: { marginBlockStart: paddingTop },
      headingLevel,
      isCtaLabelledByHeading: isCtaLabelledByHeading != null ? isCtaLabelledByHeading : void 0,
      subtitle,
      textAction: hasTextAction ? /* @__PURE__ */ React15.createElement(MasonryTextAction, { onClick, text: buttonLabel }) : void 0,
      title: heading
    }
  );
};

// src/components/masonry-notification-banner-renderer/masonry-notification-banner-renderer.component.tsx
import React17 from "react";
import { Card as Card5, useClickableCard as useClickableCard4 } from "@leagueplatform/genesis-core";

// src/components/masonry-notification-banner-renderer/masonry-notification-banner-content-renderer.tsx
import React16, { forwardRef as forwardRef3 } from "react";
import {
  Card as Card4,
  ParagraphText as ParagraphText6,
  StackLayout as StackLayout9,
  StackItem as StackItem5,
  HeadingText as HeadingText6
} from "@leagueplatform/genesis-core";
import { useMasonryEngineActionEmitter as useMasonryEngineActionEmitter8 } from "@leagueplatform/masonry-engine";
var MasonryNotificationBannerContentRenderer = forwardRef3(
  ({
    image,
    imageAltText = "",
    heading,
    body,
    onClick
  }, ref) => {
    const onClickDeeplinkAction = onClick;
    const invokeAction = useMasonryEngineActionEmitter8();
    return /* @__PURE__ */ React16.createElement(
      StackLayout9,
      {
        orientation: "horizontal",
        verticalAlignment: "stretch",
        spacing: "$one"
      },
      image && /* @__PURE__ */ React16.createElement(StackItem5, { verticalAlignment: "center" }, /* @__PURE__ */ React16.createElement(
        Card4.Image,
        {
          image,
          imageAlt: imageAltText,
          css: {
            width: "$twoAndHalf",
            height: "$twoAndHalf"
          }
        }
      )),
      /* @__PURE__ */ React16.createElement(StackLayout9, { spacing: "$quarter" }, /* @__PURE__ */ React16.createElement(HeadingText6, { size: "sm", level: "2" }, /* @__PURE__ */ React16.createElement(
        ConditionalLinkRenderer,
        {
          ref,
          url: onClickDeeplinkAction == null ? void 0 : onClickDeeplinkAction.payload.url,
          disableDefaultOnClick: true,
          onClick: (event) => {
            if (onClick) {
              invokeAction(__spreadValues({
                event
              }, onClick));
            }
          }
        },
        heading
      )), /* @__PURE__ */ React16.createElement(
        ParagraphText6,
        {
          emphasis: "subtle",
          htmlStringOptions: BodyTextHtmlTagOptions
        },
        body
      ))
    );
  }
);

// src/components/masonry-notification-banner-renderer/masonry-notification-banner-renderer.component.tsx
var MasonryNotificationBannerRenderer = ({
  heading,
  image,
  body,
  imageAltText = "",
  onClick,
  onDismiss
}) => {
  const { primaryActionRef, clickAreaRef, onCardMouseDown, onCardMouseUp } = useClickableCard4();
  return /* @__PURE__ */ React17.createElement(
    ConditionalLinkCardRenderer,
    {
      hasLink: Boolean(onClick == null ? void 0 : onClick.payload.url),
      ref: clickAreaRef,
      onCardMouseUp,
      onCardMouseDown,
      onDismiss,
      css: {
        " &:has(.GDS-card-click-area)": {
          boxShadow: "$card"
        }
      }
    },
    /* @__PURE__ */ React17.createElement(
      Card5.Section,
      {
        css: {
          padding: `${onDismiss ? "0 $oneAndHalf $oneAndHalf" : "$oneAndHalf"}`
        }
      },
      /* @__PURE__ */ React17.createElement(
        MasonryNotificationBannerContentRenderer,
        {
          image,
          imageAltText,
          heading,
          body,
          onClick,
          ref: primaryActionRef
        }
      )
    )
  );
};

// src/components/masonry-notification-card-renderer/masonry-notification-card-renderer.component.tsx
import React18 from "react";
import {
  useClickableCard as useClickableCard5,
  StackLayout as StackLayout10,
  Icon as Icon3,
  UtilityText as UtilityText6,
  HeadingText as HeadingText7,
  ParagraphText as ParagraphText7,
  StackItem as StackItem6
} from "@leagueplatform/genesis-core";
import { useMasonryEngineActionEmitter as useMasonryEngineActionEmitter9 } from "@leagueplatform/masonry-engine";
var eyebrowStyles = {
  borderRadius: "$medium",
  backgroundColor: "$surfaceBackgroundTertiary",
  padding: "$quarter $half",
  marginBottom: "$half"
};
var MasonryNotificationCardRenderer = ({
  heading,
  body,
  info,
  eyebrow,
  onClick,
  onDismiss
}) => {
  const { primaryActionRef, clickAreaRef, onCardMouseDown, onCardMouseUp } = useClickableCard5();
  const invokeAction = useMasonryEngineActionEmitter9();
  return /* @__PURE__ */ React18.createElement(
    ConditionalLinkCardRenderer,
    {
      hasLink: Boolean(onClick == null ? void 0 : onClick.payload.url),
      ref: clickAreaRef,
      onCardMouseUp,
      onCardMouseDown,
      onDismiss
    },
    /* @__PURE__ */ React18.createElement(
      StackLayout10,
      {
        orientation: "horizontal",
        verticalAlignment: "center",
        spacing: "$threeQuarters",
        css: {
          padding: "$oneAndHalf"
        }
      },
      /* @__PURE__ */ React18.createElement(StackLayout10, { css: { marginTop: "$quarter" }, verticalAlignment: "center" }, eyebrow && /* @__PURE__ */ React18.createElement(
        UtilityText6,
        {
          css: eyebrowStyles,
          size: "eyebrow",
          emphasis: "emphasized"
        },
        eyebrow
      ), /* @__PURE__ */ React18.createElement(HeadingText7, { level: "2", size: "sm" }, /* @__PURE__ */ React18.createElement(
        ConditionalLinkRenderer,
        {
          ref: primaryActionRef,
          disableDefaultOnClick: true,
          onClick: (event) => {
            if (onClick) {
              invokeAction(__spreadValues({
                event
              }, onClick));
            }
          },
          url: onClick == null ? void 0 : onClick.payload.url
        },
        heading
      )), body && /* @__PURE__ */ React18.createElement(
        ParagraphText7,
        {
          css: { "&:not(:last-child)": { marginBlockEnd: 0 } },
          htmlStringOptions: BodyTextHtmlTagOptions
        },
        body
      ), info && /* @__PURE__ */ React18.createElement(
        ParagraphText7,
        {
          emphasis: "subtle",
          size: "sm",
          htmlStringOptions: BodyTextHtmlTagOptions
        },
        info
      )),
      onClick && /* @__PURE__ */ React18.createElement(StackItem6, { verticalAlignment: "center" }, /* @__PURE__ */ React18.createElement(Icon3, { icon: "interfaceChevronForward" }))
    )
  );
};

// src/components/masonry-image-banner-renderer/masonry-image-banner-renderer.component.tsx
import React19 from "react";
import { ImageMessage } from "@leagueplatform/genesis-core";
var ImageAlignMap = {
  leading: "start",
  center: "center",
  trailing: "end"
};
var MasonryImageBannerRenderer = ({
  image,
  imageAltText = "",
  imageHeight = 50,
  imageAlign = "center"
}) => /* @__PURE__ */ React19.createElement(
  ImageMessage,
  {
    image,
    imageAlt: imageAltText,
    imageHeight,
    imageHorizontalAlignment: ImageAlignMap[imageAlign]
  }
);

// src/components/masonry-progress-bar-card-renderer/masonry-progress-bar-card-renderer.component.tsx
import React21 from "react";
import { useClickableCard as useClickableCard6 } from "@leagueplatform/genesis-core";
import { LargeImageCard } from "@leagueplatform/masonry-widgets";

// src/components/masonry-progress-bar-card-renderer/masonry-progress-bar-card-content-renderer.component.tsx
import React20 from "react";
import { ProgressBar } from "@leagueplatform/web-common-components";
import { HtmlToReact } from "@leagueplatform/web-common";
import { useMasonryEngineActionEmitter as useMasonryEngineActionEmitter10 } from "@leagueplatform/masonry-engine";
import {
  Box as Box4,
  Button as Button4,
  HeadingText as HeadingText8,
  ParagraphText as ParagraphText8,
  StackLayout as StackLayout11,
  Tooltip,
  UtilityText as UtilityText7
} from "@leagueplatform/genesis-core";
var MasonryProgressBarCardContentRenderer = ({
  eyebrow,
  heading,
  currentText,
  progress,
  suffixText,
  footerText,
  onClick,
  linkRefState,
  headingLevel,
  emphasizeCurrentValue = false,
  emphasizeFooterText = false,
  isDismissible,
  tooltipContent,
  tooltipLabel,
  tooltipIcon
}) => {
  const invokeAction = useMasonryEngineActionEmitter10();
  const onClickDeeplinkAction = onClick;
  const icon = tooltipIcon || "interfaceQuestionCircle";
  return /* @__PURE__ */ React20.createElement(
    StackLayout11,
    {
      orientation: "vertical",
      spacing: "$quarter",
      css: {
        margin: `${isDismissible ? "$three $oneAndHalf $oneAndHalf $oneAndHalf" : "$oneAndHalf"}`,
        alignItems: "normal",
        height: "auto"
      }
    },
    eyebrow && /* @__PURE__ */ React20.createElement(UtilityText7, { as: "p", size: "eyebrow", css: { marginBottom: "$quarter" } }, eyebrow),
    /* @__PURE__ */ React20.createElement(StackLayout11, { spacing: "$threeQuarters", orientation: "vertical" }, /* @__PURE__ */ React20.createElement(StackLayout11, { orientation: "horizontal", verticalAlignment: "center" }, heading && /* @__PURE__ */ React20.createElement(
      HeadingText8,
      {
        level: headingLevel || "3",
        size: "sm",
        css: { paddingRight: "$quarter" }
      },
      heading
    ), tooltipContent && /* @__PURE__ */ React20.createElement(
      Tooltip,
      {
        align: "start",
        side: "top",
        content: /* @__PURE__ */ React20.createElement(HtmlToReact, { htmlString: tooltipContent }),
        css: { maxWidth: "360px" }
      },
      /* @__PURE__ */ React20.createElement(
        Button4,
        {
          size: "small",
          icon,
          hideLabel: true,
          quiet: true,
          priority: "secondary"
        },
        tooltipLabel
      )
    )), /* @__PURE__ */ React20.createElement(ParagraphText8, { size: "sm" }, /* @__PURE__ */ React20.createElement(
      ConditionalLinkRenderer,
      {
        disableDefaultOnClick: true,
        ref: linkRefState,
        url: onClickDeeplinkAction == null ? void 0 : onClickDeeplinkAction.payload.url,
        onClick: (event) => {
          if (onClick) {
            invokeAction(__spreadValues({
              event
            }, onClick));
          }
        }
      },
      /* @__PURE__ */ React20.createElement(
        UtilityText7,
        {
          size: "sm",
          emphasis: emphasizeCurrentValue ? "emphasized" : "base"
        },
        currentText
      ),
      " ",
      suffixText
    )), /* @__PURE__ */ React20.createElement(Box4, { css: { paddingBottom: "$half", width: "100%" } }, /* @__PURE__ */ React20.createElement(
      ProgressBar,
      {
        total: 100,
        current: progress,
        customBarFillColor: "success.border.default",
        customBarBackgroundColor: "success.background.subdued",
        screenReaderText: `${currentText} ${suffixText}`
      }
    )), /* @__PURE__ */ React20.createElement(
      UtilityText7,
      {
        emphasis: emphasizeFooterText ? "emphasized" : "subtle",
        size: "sm",
        css: {
          alignSelf: "flex-end"
        }
      },
      footerText
    ))
  );
};

// src/components/masonry-progress-bar-card-renderer/masonry-progress-bar-card-renderer.component.tsx
var MasonryProgressBarCardWithoutImage = ({
  eyebrow,
  heading,
  currentText,
  progress,
  suffixText,
  footerText,
  emphasizeCurrentValue,
  emphasizeFooterText,
  onClick,
  isDismissible,
  primaryActionRef,
  headingLevel,
  tooltipIcon,
  tooltipLabel,
  tooltipContent
}) => /* @__PURE__ */ React21.createElement(
  MasonryProgressBarCardContentRenderer,
  {
    eyebrow,
    heading,
    currentText,
    progress,
    suffixText,
    footerText,
    linkRefState: primaryActionRef,
    emphasizeCurrentValue,
    emphasizeFooterText,
    onClick,
    isDismissible,
    headingLevel,
    tooltipIcon,
    tooltipLabel,
    tooltipContent
  }
);
var MasonryProgressBarCardWithImage = ({
  eyebrow,
  heading,
  image,
  imageAltText = "",
  currentText,
  progress,
  suffixText,
  footerText,
  onClick,
  isDismissible,
  isChildItem = false,
  emphasizeCurrentValue,
  emphasizeFooterText,
  primaryActionRef,
  headingLevel,
  tooltipIcon,
  tooltipLabel,
  tooltipContent
}) => /* @__PURE__ */ React21.createElement(
  LargeImageCard,
  {
    image,
    imageAltText,
    isChildItem
  },
  /* @__PURE__ */ React21.createElement(
    MasonryProgressBarCardContentRenderer,
    {
      eyebrow,
      heading,
      currentText,
      progress,
      suffixText,
      footerText,
      linkRefState: primaryActionRef,
      emphasizeCurrentValue,
      emphasizeFooterText,
      onClick,
      isDismissible,
      headingLevel,
      tooltipIcon,
      tooltipLabel,
      tooltipContent
    }
  )
);
var MasonryProgressBarCardRenderer = (_a) => {
  var _b = _a, {
    isChildItem
  } = _b, props = __objRest(_b, [
    "isChildItem"
  ]);
  const isDismissible = Boolean(props.onDismiss);
  const { image, onClick } = props;
  const { primaryActionRef, clickAreaRef, onCardMouseDown, onCardMouseUp } = useClickableCard6();
  return /* @__PURE__ */ React21.createElement(
    ConditionalLinkCardRenderer,
    {
      hasLink: Boolean(onClick == null ? void 0 : onClick.payload.url),
      ref: clickAreaRef,
      onCardMouseUp,
      onCardMouseDown,
      onDismiss: props.onDismiss,
      hasFloatingDismissButton: true,
      imagePosition: isChildItem ? "top" : {
        "@initial": "start",
        "@mobile": "top"
      }
    },
    image ? /* @__PURE__ */ React21.createElement(
      MasonryProgressBarCardWithImage,
      __spreadValues({
        isChildItem,
        image,
        primaryActionRef,
        onClick,
        isDismissible
      }, props)
    ) : /* @__PURE__ */ React21.createElement(
      MasonryProgressBarCardWithoutImage,
      __spreadValues({
        primaryActionRef,
        onClick,
        isDismissible
      }, props)
    )
  );
};

// src/components/masonry-progress-ring-card-renderer/masonry-progress-ring-card-renderer.component.tsx
import React22 from "react";
import { ProgressRing } from "@leagueplatform/web-common-components";
import {
  Box as Box5,
  HeadingText as HeadingText9,
  ParagraphText as ParagraphText9,
  UtilityText as UtilityText8,
  StackLayout as StackLayout12,
  useClickableCard as useClickableCard7
} from "@leagueplatform/genesis-core";
import {
  useMasonryEngineActionEmitter as useMasonryEngineActionEmitter11
} from "@leagueplatform/masonry-engine";
var PROGRESS_RING_DIMENSION = 82;
var MasonryProgressRingCardRenderer = ({
  heading,
  eyebrow,
  currentText,
  suffixText = "",
  footerText,
  image,
  imageAltText = "",
  progress,
  onClick,
  onDismiss,
  emphasizeCurrentValue = false
}) => {
  const { primaryActionRef, clickAreaRef, onCardMouseDown, onCardMouseUp } = useClickableCard7();
  const invokeAction = useMasonryEngineActionEmitter11();
  return /* @__PURE__ */ React22.createElement(
    ConditionalLinkCardRenderer,
    {
      ref: clickAreaRef,
      onCardMouseUp,
      onCardMouseDown,
      hasLink: Boolean(onClick == null ? void 0 : onClick.payload.url),
      onDismiss,
      hasFloatingDismissButton: true,
      css: {
        marginTop: `calc(${PROGRESS_RING_DIMENSION}px/2)`,
        overflow: "visible",
        "& .GDS-card-click-area": {
          overflow: "visible"
        }
      }
    },
    /* @__PURE__ */ React22.createElement(
      StackLayout12,
      {
        horizontalAlignment: "stretch",
        css: { padding: "$oneAndHalf", overflow: "visible" }
      },
      /* @__PURE__ */ React22.createElement(
        Box5,
        {
          css: {
            width: `${PROGRESS_RING_DIMENSION}px`,
            height: `${PROGRESS_RING_DIMENSION}px`,
            position: "relative",
            // Progress Ring Height + Card Padding
            transform: `${`translateY(calc(-50% - ${"$space$oneAndHalf"}))`}`,
            // Progress Ring Height - Card Padding + Progress Ring Margin Bottom
            marginBottom: `${`calc(-${PROGRESS_RING_DIMENSION}px/2 - ${"$space$oneAndHalf"} + ${"$space$threeQuarters"})`}`,
            alignSelf: "center"
          }
        },
        /* @__PURE__ */ React22.createElement(
          ProgressRing,
          {
            size: PROGRESS_RING_DIMENSION,
            total: 100,
            current: progress,
            customRingFillColor: "success.border.default",
            customRingBackgroundColor: "success.background.subdued",
            screenReaderText: `${currentText} ${suffixText || ""}`,
            image,
            imageAltText
          }
        )
      ),
      /* @__PURE__ */ React22.createElement(
        StackLayout12,
        {
          spacing: "$threeQuarters",
          horizontalAlignment: "center",
          css: { width: "100%", textAlign: "center" }
        },
        eyebrow && /* @__PURE__ */ React22.createElement(
          UtilityText8,
          {
            css: {
              color: "$onSurfaceTextSubdued"
            },
            size: "eyebrow"
          },
          eyebrow
        ),
        heading && /* @__PURE__ */ React22.createElement(
          HeadingText9,
          {
            level: "display",
            css: { marginTop: "$quarter !important" },
            size: "sm"
          },
          heading
        ),
        /* @__PURE__ */ React22.createElement(ParagraphText9, { as: "h3", size: "sm" }, /* @__PURE__ */ React22.createElement(
          ConditionalLinkRenderer,
          {
            disableDefaultOnClick: true,
            ref: primaryActionRef,
            url: onClick == null ? void 0 : onClick.payload.url,
            onClick: (event) => {
              if (onClick) {
                invokeAction(__spreadValues({
                  event
                }, onClick));
              }
            },
            css: {
              color: "$onSurfaceTextPrimary"
            }
          },
          /* @__PURE__ */ React22.createElement(
            ParagraphText9,
            {
              as: "span",
              size: "sm",
              css: {
                fontWeight: emphasizeCurrentValue ? "bold" : "400"
              }
            },
            currentText
          ),
          " ",
          suffixText
        )),
        footerText && /* @__PURE__ */ React22.createElement(ParagraphText9, { size: "xs", css: { color: "$onSurfaceTextSubdued" } }, footerText)
      )
    )
  );
};

// src/components/masonry-micro-card-renderer/masonry-micro-card-renderer.component.tsx
import React23 from "react";
import {
  HeadingText as HeadingText10,
  ParagraphText as ParagraphText10,
  StackLayout as StackLayout13,
  useClickableCard as useClickableCard8,
  styled as styled5,
  Image as Image3
} from "@leagueplatform/genesis-core";
import {
  useMasonryEngineActionEmitter as useMasonryEngineActionEmitter12
} from "@leagueplatform/masonry-engine";
var StyledImage2 = styled5(Image3, {
  width: "4.2rem",
  height: "4.2rem"
});
var MasonryMicroCardRenderer = ({
  heading,
  body,
  imageAltText = "",
  image,
  onClick,
  onDismiss
}) => {
  const { primaryActionRef, clickAreaRef, onCardMouseDown, onCardMouseUp } = useClickableCard8();
  const invokeAction = useMasonryEngineActionEmitter12();
  const onClickAsDeeplinkAction = onClick;
  return /* @__PURE__ */ React23.createElement(
    ConditionalLinkCardRenderer,
    {
      hasLink: Boolean(onClickAsDeeplinkAction == null ? void 0 : onClickAsDeeplinkAction.payload.url),
      ref: clickAreaRef,
      onCardMouseUp,
      onCardMouseDown,
      onDismiss,
      css: {
        width: "100%"
      }
    },
    /* @__PURE__ */ React23.createElement(
      StackLayout13,
      {
        orientation: "horizontal",
        spacing: "$half",
        css: { padding: "$oneAndHalf" }
      },
      /* @__PURE__ */ React23.createElement(StyledImage2, { src: image, alt: imageAltText }),
      /* @__PURE__ */ React23.createElement(StackLayout13, { spacing: "$quarter" }, /* @__PURE__ */ React23.createElement(HeadingText10, { size: "sm", level: !body ? "display" : "3" }, /* @__PURE__ */ React23.createElement(
        ConditionalLinkRenderer,
        {
          disableDefaultOnClick: true,
          ref: primaryActionRef,
          onClick: (event) => {
            if (onClick) {
              invokeAction(__spreadValues({
                event
              }, onClick));
            }
          },
          url: onClickAsDeeplinkAction == null ? void 0 : onClickAsDeeplinkAction.payload.url
        },
        heading
      )), body && /* @__PURE__ */ React23.createElement(ParagraphText10, { htmlStringOptions: BodyTextHtmlTagOptions }, body))
    )
  );
};

// src/components/masonry-metric-card-renderer/masonry-metric-card-renderer.component.tsx
import * as React24 from "react";
import {
  HeadingText as HeadingText11,
  Icon as Icon4,
  ParagraphText as ParagraphText11,
  StackLayout as StackLayout14,
  styled as styled6,
  UtilityText as UtilityText9,
  useClickableCard as useClickableCard9,
  Image as Image4
} from "@leagueplatform/genesis-core";
import { HtmlToReact as HtmlToReact2 } from "@leagueplatform/web-common";
import {
  useMasonryEngineActionEmitter as useMasonryEngineActionEmitter13
} from "@leagueplatform/masonry-engine";
var StyledImage3 = styled6(Image4, {
  contentFit: "cover",
  contentPosition: "center",
  width: "$three",
  height: "$three"
});
function MasonryMetricCardRenderer({
  heading,
  measurements,
  body,
  timestamp,
  image,
  imageAltText = "",
  onClick,
  onDismiss
}) {
  const { primaryActionRef, clickAreaRef, onCardMouseDown, onCardMouseUp } = useClickableCard9();
  const displayMeasurements = !!(measurements == null ? void 0 : measurements.length);
  const displayBody = !displayMeasurements && !!body;
  const invokeAction = useMasonryEngineActionEmitter13();
  return /* @__PURE__ */ React24.createElement(
    ConditionalLinkCardRenderer,
    {
      ref: clickAreaRef,
      onCardMouseUp,
      onCardMouseDown,
      hasLink: Boolean(onClick == null ? void 0 : onClick.payload.url),
      onDismiss
    },
    /* @__PURE__ */ React24.createElement(
      StackLayout14,
      {
        orientation: "horizontal",
        verticalAlignment: "center",
        horizontalAlignment: "spaceBetween",
        spacing: "$threeQuarters",
        css: {
          padding: `${onDismiss ? "0 $oneAndHalf $oneAndHalf " : "$oneAndHalf"}`,
          flexWrap: "wrap"
        }
      },
      image && /* @__PURE__ */ React24.createElement(StyledImage3, { src: image, alt: imageAltText }),
      /* @__PURE__ */ React24.createElement(
        StackLayout14,
        {
          css: {
            width: "100%"
          },
          orientation: "horizontal",
          horizontalAlignment: "spaceBetween"
        },
        /* @__PURE__ */ React24.createElement(
          StackLayout14,
          {
            css: {
              width: "100%"
            },
            spacing: "$quarter",
            verticalAlignment: "spaceBetween"
          },
          /* @__PURE__ */ React24.createElement(
            HeadingText11,
            {
              size: "sm",
              level: !body ? "display" : "3",
              color: "$onSurfaceTextPrimary"
            },
            /* @__PURE__ */ React24.createElement(
              ConditionalLinkRenderer,
              {
                disableDefaultOnClick: true,
                ref: primaryActionRef,
                onClick: (event) => {
                  if (onClick) {
                    invokeAction(__spreadValues({
                      event
                    }, onClick));
                  }
                },
                url: onClick == null ? void 0 : onClick.payload.url
              },
              heading
            )
          ),
          displayMeasurements ? /* @__PURE__ */ React24.createElement(StackLayout14, { orientation: "horizontal" }, /* @__PURE__ */ React24.createElement(
            ParagraphText11,
            {
              "data-testid": "measurement",
              css: {
                marginInlineEnd: "$threeQuarters",
                width: "100%",
                "&&": {
                  marginBlockEnd: "$none"
                }
              }
            },
            measurements.map(({ value, unit }) => /* @__PURE__ */ React24.createElement(React24.Fragment, { key: `${value}${unit}` }, /* @__PURE__ */ React24.createElement(
              UtilityText9,
              {
                css: {
                  paddingInlineEnd: "$quarter",
                  typography: "$headingThree"
                }
              },
              value
            ), unit && /* @__PURE__ */ React24.createElement(
              UtilityText9,
              {
                css: {
                  typography: "$label",
                  color: "$onSurfaceTextSubdued",
                  paddingInlineEnd: "$quarter"
                }
              },
              unit,
              " "
            )))
          )) : null,
          displayBody ? /* @__PURE__ */ React24.createElement(
            UtilityText9,
            {
              css: {
                typography: "$caption",
                color: "$onSurfaceTextSubdued"
              }
            },
            /* @__PURE__ */ React24.createElement(HtmlToReact2, { htmlString: body })
          ) : null
        ),
        timestamp && /* @__PURE__ */ React24.createElement(
          ParagraphText11,
          {
            css: {
              typography: "$label",
              color: "$onSurfaceTextSubdued"
            }
          },
          timestamp
        )
      ),
      (onClick == null ? void 0 : onClick.payload.url) && /* @__PURE__ */ React24.createElement(
        Icon4,
        {
          size: 24,
          icon: "interfaceChevronForward",
          tint: "$onSurfaceIconPrimary"
        }
      )
    )
  );
}

// src/components/masonry-column-layout-renderer/masonry-column-layout-renderer.component.tsx
import * as React25 from "react";
import {
  Column,
  ColumnLayout,
  HeadingText as HeadingText12,
  ParagraphText as ParagraphText12,
  StackLayout as StackLayout15
} from "@leagueplatform/genesis-core";
import { merge } from "lodash";
var MasonryColumnLayoutRenderer = ({
  column_1,
  column_2,
  heading,
  body
}) => {
  var _a;
  return /* @__PURE__ */ React25.createElement(StackLayout15, null, /* @__PURE__ */ React25.createElement(HeadingText12, { level: "2", size: "xl" }, heading), /* @__PURE__ */ React25.createElement(ParagraphText12, null, body), /* @__PURE__ */ React25.createElement(
    ColumnLayout,
    {
      css: {
        width: "100%",
        maxWidth: "100%",
        gap: "$none",
        "@desktop": {
          gap: "50px"
        },
        "@laptop": {
          gap: "40px"
        }
      },
      background: "primary",
      spacingStart: {
        "@initial": "$none",
        "@mobile": "$two",
        "@tablet": "$two",
        "@laptop": "$none",
        "@desktop": "$none"
      },
      spacingEnd: {
        "@initial": "$none",
        "@mobile": "$two",
        "@tablet": "$two",
        "@laptop": "$none",
        "@desktop": "$none"
      }
    },
    /* @__PURE__ */ React25.createElement(
      Column,
      {
        offset: 0,
        order: {
          "@initial": 12,
          "@mobile": 2,
          "@tablet": 2,
          "@laptop": 1,
          "@desktop": 1
        },
        width: {
          "@initial": 12,
          "@mobile": 12,
          "@tablet": 12,
          "@laptop": 8,
          "@desktop": 9
        }
      },
      /* @__PURE__ */ React25.createElement(
        StackLayout15,
        {
          orientation: "vertical",
          horizontalAlignment: "stretch",
          spacing: "$two"
        },
        column_1
      )
    ),
    /* @__PURE__ */ React25.createElement(
      Column,
      {
        offset: 0,
        order: {
          "@initial": 12,
          "@mobile": 1,
          "@tablet": 1,
          "@laptop": 2,
          "@desktop": 2
        },
        width: {
          "@initial": 12,
          "@mobile": 12,
          "@tablet": 12,
          "@laptop": 4,
          "@desktop": 3
        },
        css: {
          marginTop: "$none",
          "@mobile": {
            marginTop: "$oneAndHalf"
          },
          "@tablet": {
            marginTop: "$oneAndHalf"
          }
        }
      },
      /* @__PURE__ */ React25.createElement(
        StackLayout15,
        {
          css: { height: "auto" },
          orientation: "vertical",
          horizontalAlignment: "stretch",
          spacing: "$two"
        },
        (_a = React25.Children) == null ? void 0 : _a.map(
          column_2,
          (child) => React25.cloneElement(child, {
            node: merge(
              {},
              child.props.node,
              {
                properties: { isChildItem: true }
              }
            )
          })
        )
      )
    )
  ));
};

// src/components/masonry-carousel-renderer/masonry-carousel-renderer.component.tsx
import * as React27 from "react";
import { merge as merge2, uniqueId as uniqueId3 } from "lodash";
import {
  useMasonryEngineActionEmitter as useMasonryEngineActionEmitter14
} from "@leagueplatform/masonry-engine";
import {
  Carousel,
  NoPeekCarousel
} from "@leagueplatform/web-common-components";
import {
  ParagraphText as ParagraphText13,
  StackItem as StackItem7
} from "@leagueplatform/genesis-core";

// src/constants.ts
var COMPLEX_WIDGET_CARDS_WIDTH = "275px";
var COMPLEX_WIDGET_CARDS_WIDTH_MOBILE = "200px";

// src/components/masonry-section-header-renderer/section-header.component.tsx
import * as React26 from "react";
import { SectionHeader as SectionHeaderComponent } from "@leagueplatform/genesis-core-alpha";
var SectionHeader2 = ({
  heading,
  headingLevel = "2",
  paddingTop = "$one",
  textAction
}) => /* @__PURE__ */ React26.createElement(
  SectionHeaderComponent,
  {
    css: { marginBlockStart: paddingTop },
    headingLevel,
    title: heading,
    textAction
  }
);

// src/components/masonry-carousel-renderer/masonry-carousel-renderer.component.tsx
var MasonryCarouselRenderer = (_a) => {
  var _b = _a, {
    heading,
    body,
    headerButtonLabel,
    items,
    onHeaderButtonClick,
    onScrollLeft,
    onScrollRight,
    noPeek
  } = _b, props = __objRest(_b, [
    "heading",
    "body",
    "headerButtonLabel",
    "items",
    "onHeaderButtonClick",
    "onScrollLeft",
    "onScrollRight",
    "noPeek"
  ]);
  var _a2;
  const invokeAction = useMasonryEngineActionEmitter14();
  const CarouselComponent = !noPeek ? Carousel : NoPeekCarousel;
  const headingId = React27.useMemo(
    () => uniqueId3("MasonryCarouselRenderer"),
    []
  );
  if (!items)
    return null;
  return /* @__PURE__ */ React27.createElement(
    CarouselComponent,
    __spreadValues(__spreadProps(__spreadValues({
      name: heading || "masonry-carousel",
      heading: heading ? /* @__PURE__ */ React27.createElement(
        SectionHeader2,
        __spreadValues({
          heading,
          paddingTop: "$none"
        }, { id: headingId })
      ) : void 0,
      headingLabelledBy: headingId,
      description: /* @__PURE__ */ React27.createElement(ParagraphText13, { htmlStringOptions: BodyTextHtmlTagOptions }, body)
    }, !noPeek && { spaceBetweenCards: "oneAndHalf" }), {
      linkCta: headerButtonLabel,
      linkUrl: onHeaderButtonClick == null ? void 0 : onHeaderButtonClick.payload.url,
      linkOnClick: (event) => {
        if (onHeaderButtonClick) {
          invokeAction(__spreadValues({
            event
          }, onHeaderButtonClick));
        }
      },
      BackNavButtonAnalyticsFn: () => {
        if (onScrollLeft) {
          invokeAction(__spreadValues({}, onScrollLeft));
        }
      },
      ForwardNavButtonAnalyticsFn: () => {
        if (onScrollRight) {
          invokeAction(__spreadValues({}, onScrollRight));
        }
      }
    }), props),
    (_a2 = React27.Children) == null ? void 0 : _a2.map(items, (child) => /* @__PURE__ */ React27.createElement(
      StackItem7,
      {
        css: {
          minWidth: COMPLEX_WIDGET_CARDS_WIDTH,
          height: "100%",
          "@mobile": {
            minWidth: COMPLEX_WIDGET_CARDS_WIDTH_MOBILE
          }
        }
      },
      React27.cloneElement(child, {
        node: merge2(
          {},
          child.props.node,
          {
            properties: { isChildItem: true }
          }
        )
      })
    ))
  );
};

// src/components/masonry-vertical-layout-renderer/masonry-vertical-layout-renderer.component.tsx
import * as React28 from "react";
import {
  StackLayout as StackLayout16,
  StackItem as StackItem8,
  ParagraphText as ParagraphText14,
  spacingTokenMap
} from "@leagueplatform/genesis-core";
var MasonryVerticalLayoutRenderer = ({
  body,
  headerButtonLabel,
  heading,
  headingLevel,
  isSemanticList,
  items,
  onHeaderButtonClick,
  spacing = "one"
}) => {
  const hasTextAction = !!onHeaderButtonClick && !!headerButtonLabel;
  if (!items)
    return null;
  const layoutSpacing = spacingTokenMap[spacing];
  return /* @__PURE__ */ React28.createElement(
    StackLayout16,
    {
      spacing: "$one",
      horizontalAlignment: "stretch",
      orientation: "vertical"
    },
    heading && /* @__PURE__ */ React28.createElement(
      SectionHeader2,
      {
        headingLevel,
        heading,
        textAction: hasTextAction ? /* @__PURE__ */ React28.createElement(
          MasonryTextAction,
          {
            onClick: onHeaderButtonClick,
            text: headerButtonLabel
          }
        ) : void 0
      }
    ),
    body && /* @__PURE__ */ React28.createElement(ParagraphText14, null, body),
    items && /* @__PURE__ */ React28.createElement(
      StackLayout16,
      {
        as: isSemanticList ? "ul" : "div",
        spacing: layoutSpacing != null ? layoutSpacing : "$one",
        horizontalAlignment: "stretch",
        orientation: "vertical"
      },
      React28.Children.map(
        items,
        (item) => item && /* @__PURE__ */ React28.createElement(
          StackItem8,
          {
            as: isSemanticList ? "li" : "div",
            verticalAlignment: "bottom"
          },
          item
        )
      )
    )
  );
};

// src/components/masonry-horizontal-layout-renderer/masonry-horizontal-layout-renderer.component.tsx
import * as React29 from "react";
import { merge as merge3 } from "lodash";
import {
  StackLayout as StackLayout17,
  StackItem as StackItem9,
  ParagraphText as ParagraphText15,
  spacingTokenMap as spacingTokenMap2
} from "@leagueplatform/genesis-core";
var MasonryHorizontalLayoutRenderer = ({
  body,
  headerButtonLabel,
  heading,
  headingLevel,
  isSemanticList,
  items,
  onHeaderButtonClick,
  spacing = "one"
}) => {
  const hasTextAction = Boolean(
    onHeaderButtonClick && headerButtonLabel
  );
  if (!items)
    return null;
  const itemSpacing = spacingTokenMap2[spacing];
  return /* @__PURE__ */ React29.createElement(
    StackLayout17,
    {
      spacing: "$one",
      horizontalAlignment: "stretch",
      orientation: "vertical"
    },
    heading && /* @__PURE__ */ React29.createElement(
      SectionHeader2,
      {
        headingLevel,
        heading,
        textAction: hasTextAction ? /* @__PURE__ */ React29.createElement(
          MasonryTextAction,
          {
            onClick: onHeaderButtonClick,
            text: headerButtonLabel
          }
        ) : void 0
      }
    ),
    body && /* @__PURE__ */ React29.createElement(ParagraphText15, null, body),
    /* @__PURE__ */ React29.createElement(
      StackLayout17,
      {
        as: isSemanticList ? "ul" : "div",
        horizontalAlignment: "stretch",
        orientation: "horizontal",
        spacing: itemSpacing != null ? itemSpacing : "$one",
        verticalAlignment: "stretch"
      },
      items && React29.Children.map(
        items,
        (item) => item != null ? item : /* @__PURE__ */ React29.createElement(
          StackItem9,
          {
            as: isSemanticList ? "li" : "div",
            css: { minWidth: COMPLEX_WIDGET_CARDS_WIDTH },
            verticalAlignment: "fillContainer"
          },
          React29.cloneElement(item, {
            node: merge3({}, item.props.node, {
              properties: { isChildItem: true }
            })
          })
        )
      )
    )
  );
};

// src/components/masonry-grid-layout-renderer/masonry-grid-layout-renderer.component.tsx
import * as React31 from "react";
import {
  Box as Box7,
  StackLayout as StackLayout18,
  ParagraphText as ParagraphText16,
  spacingTokenMap as spacingTokenMap3
} from "@leagueplatform/genesis-core";

// src/common/grid-container/grid-container.tsx
import { Box as Box6 } from "@leagueplatform/genesis-core";
import * as React30 from "react";
var DEFAULT_STYLES = {
  MIN_GRID_ITEM_WIDTH: "250px",
  MIN_MOBILE_GRID_ITEM_WIDTH: "200px",
  GRID_COLUMN_COUNT: 2,
  SPACING: "$one"
};
function GridContainer({
  as,
  gridColumnCount = DEFAULT_STYLES.GRID_COLUMN_COUNT,
  minGridItemWidth = DEFAULT_STYLES.MIN_GRID_ITEM_WIDTH,
  mobileMinGridItemWidth = DEFAULT_STYLES.MIN_MOBILE_GRID_ITEM_WIDTH,
  spacing = DEFAULT_STYLES.SPACING,
  children
}) {
  const gapCount = gridColumnCount - 1;
  const totalGapWidth = `${gapCount} * ${spacing}`;
  const maxGridItemWidth = `calc((100% - ${totalGapWidth}) / ${gridColumnCount})`;
  return /* @__PURE__ */ React30.createElement(
    Box6,
    {
      as,
      css: {
        display: "grid",
        gridTemplateColumns: `repeat(auto-fill, minmax(max(${minGridItemWidth}, ${maxGridItemWidth}), 1fr));`,
        gridGap: spacing,
        "@mobile": {
          gridTemplateColumns: `repeat(auto-fill, minmax(${mobileMinGridItemWidth}, 1fr));`
        }
      }
    },
    children
  );
}

// src/components/masonry-grid-layout-renderer/masonry-grid-layout-renderer.component.tsx
var MasonryGridLayoutRenderer = ({
  body,
  columnCount = 2,
  heading,
  isSemanticList,
  items,
  headerButtonLabel,
  onHeaderButtonClick,
  spacing = "one"
}) => {
  const hasTextAction = !!onHeaderButtonClick && !!headerButtonLabel;
  if (!items)
    return null;
  const gridSpacing = spacingTokenMap3[spacing];
  return /* @__PURE__ */ React31.createElement(
    StackLayout18,
    {
      spacing: "$one",
      horizontalAlignment: "stretch",
      orientation: "vertical"
    },
    heading && /* @__PURE__ */ React31.createElement(
      SectionHeader2,
      {
        textAction: hasTextAction ? /* @__PURE__ */ React31.createElement(
          MasonryTextAction,
          {
            onClick: onHeaderButtonClick,
            text: headerButtonLabel
          }
        ) : void 0,
        heading
      }
    ),
    body && /* @__PURE__ */ React31.createElement(ParagraphText16, null, body),
    items && /* @__PURE__ */ React31.createElement(
      GridContainer,
      {
        as: isSemanticList ? "ul" : "div",
        spacing: gridSpacing,
        gridColumnCount: columnCount
      },
      isSemanticList ? React31.Children.map(
        items,
        (item) => item && /* @__PURE__ */ React31.createElement(Box7, { as: isSemanticList ? "li" : "div" }, item)
      ) : items
    )
  );
};

// src/components/masonry-loader-renderer/masonry-loader-renderer.tsx
import * as React32 from "react";
import {
  LargeSkeleton,
  SmallSkeleton,
  ExtraSmallSkeleton,
  HeroBannerSkeleton
} from "@leagueplatform/masonry-widgets";
var MasonryLoaderRenderer = ({ type }) => {
  switch (type) {
    case "extraSmall":
      return /* @__PURE__ */ React32.createElement(ExtraSmallSkeleton, null);
    case "small":
      return /* @__PURE__ */ React32.createElement(SmallSkeleton, null);
    case "large":
      return /* @__PURE__ */ React32.createElement(LargeSkeleton, null);
    case "heroBanner":
      return /* @__PURE__ */ React32.createElement(HeroBannerSkeleton, null);
    default:
      return null;
  }
};

// src/components/masonry-tabs-renderer/masonry-tabs-renderer.component.tsx
import * as React33 from "react";
import { Tabs } from "@leagueplatform/genesis-core";
import {
  useMasonryEngineActionEmitter as useMasonryEngineActionEmitter15
} from "@leagueplatform/masonry-engine";
var MasonryTabsRenderer = ({
  items,
  defaultSelectedTabId,
  tabList = [],
  tabListName,
  onClick
}) => {
  var _a;
  const invokeAction = useMasonryEngineActionEmitter15();
  const initialTabId = defaultSelectedTabId || ((_a = tabList[0]) == null ? void 0 : _a.id);
  const [visitedTabPanels, setVisitedTabPanels] = React33.useState(
    /* @__PURE__ */ new Set([initialTabId])
  );
  const [selectedTabId, setSelectedTabId] = React33.useState(initialTabId);
  if (!items || !tabList.length)
    return null;
  const handleOnClick = (tabId) => {
    if (!onClick)
      return;
    if (onClick == null ? void 0 : onClick.analytics) {
      invokeAction(__spreadProps(__spreadValues({}, onClick), {
        analytics: __spreadProps(__spreadValues({}, onClick.analytics), { tabId })
      }));
      return;
    }
    invokeAction(onClick);
  };
  return /* @__PURE__ */ React33.createElement(
    Tabs.Root,
    {
      value: selectedTabId,
      onValueChange: (tabId) => {
        setVisitedTabPanels((prev) => /* @__PURE__ */ new Set([...prev, tabId]));
        setSelectedTabId(tabId);
      }
    },
    /* @__PURE__ */ React33.createElement(
      Tabs.TabList,
      {
        "aria-label": tabListName != null ? tabListName : void 0,
        divider: true,
        tabDistribution: "hugContents"
      },
      tabList.map((tab) => {
        var _a2, _b;
        return /* @__PURE__ */ React33.createElement(
          Tabs.Tab,
          {
            key: `${tab.id}-tab-button`,
            value: tab.id,
            onClick: () => {
              handleOnClick(tab.id);
            },
            icon: (_a2 = tab.leadingIcon) == null ? void 0 : _a2.value,
            iconLabel: (_b = tab.leadingIcon) == null ? void 0 : _b.iconAltText
          },
          tab.title
        );
      })
    ),
    React33.Children.toArray(items).map((item, index) => {
      var _a2;
      if (!((_a2 = tabList[index]) == null ? void 0 : _a2.id))
        return null;
      const isHidden = tabList[index].id !== selectedTabId;
      return /* @__PURE__ */ React33.createElement(
        Tabs.TabPanel,
        {
          key: `${tabList[index].id}-tabpanel`,
          value: tabList[index].id,
          forceMount: visitedTabPanels.has(tabList[index].id) || void 0,
          hidden: isHidden,
          "aria-hidden": isHidden
        },
        item
      );
    })
  );
};

// src/components/masonry-sidebar-layout-renderer/masonry-sidebar-layout-renderer.component.tsx
import * as React34 from "react";
import {
  spacingTokenMap as spacingTokenMap4
} from "@leagueplatform/genesis-core";
import {
  SidebarLayout
} from "@leagueplatform/genesis-core-alpha";
var MasonrySidebarLayoutRenderer = ({
  items,
  spacing: spacingToken = "one",
  sidebarSide,
  sidebarSize,
  verticalBreakpoint
}) => {
  if (!items || !items.length)
    return null;
  const spacing = spacingTokenMap4[spacingToken];
  return /* @__PURE__ */ React34.createElement(
    SidebarLayout,
    {
      spacing,
      sidebarSide,
      sidebarSize,
      verticalBreakpoint
    },
    items
  );
};

// src/components/masonry-text-action-renderer/masonry-text-action-renderer.component.tsx
import React35 from "react";
var indicatorIconMap = {
  disclosure: "disclosure",
  externalLink: "externalLink",
  newWindowInternal: "newTabInternal",
  none: void 0
};
var MasonryTextActionRenderer = ({
  icon,
  indicator: indicatorName = "none",
  onClick,
  size = "large",
  text,
  variant
}) => {
  if (!text) {
    return null;
  }
  const indicator = indicatorIconMap[indicatorName];
  return /* @__PURE__ */ React35.createElement(
    MasonryTextAction,
    {
      icon,
      indicator,
      size,
      text,
      onClick,
      variant
    }
  );
};

// src/components/masonry-button-renderer/masonry-button-renderer.component.tsx
import React36 from "react";
import {
  useMasonryEngineActionEmitter as useMasonryEngineActionEmitter16
} from "@leagueplatform/masonry-engine";
import { Button as Button5 } from "@leagueplatform/genesis-core";

// src/utils/is-link-action.ts
var linkActionTypes = ["deeplink"];
var isLinkAction = (action) => Boolean((action == null ? void 0 : action.type) && linkActionTypes.includes(action.type));

// src/components/masonry-button-renderer/masonry-button-renderer.component.tsx
var MasonryButtonRenderer = ({
  label,
  destructive,
  disabled,
  hideLabel,
  icon,
  id,
  indicator,
  loading,
  loadingText,
  onClick,
  priority,
  quiet,
  size,
  textAlign,
  truncateLabel,
  type,
  width
}) => {
  const invokeAction = useMasonryEngineActionEmitter16();
  const onClickDeeplinkAction = onClick;
  const isLink = isLinkAction(onClickDeeplinkAction);
  return /* @__PURE__ */ React36.createElement(
    Button5,
    __spreadProps(__spreadValues({
      id,
      type,
      size,
      indicator,
      width,
      destructive,
      quiet,
      disabled,
      loading,
      loadingText,
      icon,
      hideLabel,
      truncateLabel,
      priority,
      textAlign
    }, isLink && {
      as: "a",
      href: onClickDeeplinkAction == null ? void 0 : onClickDeeplinkAction.payload.url
    }), {
      onClick: onClick ? (event) => {
        invokeAction(__spreadValues({
          event
        }, onClick));
      } : void 0
    }),
    label
  );
};

// src/components/masonry-video-renderer/masonry-video-renderer.component.tsx
import React37, { useCallback as useCallback2 } from "react";
import {
  useMasonryEngineActionEmitter as useMasonryEngineActionEmitter17
} from "@leagueplatform/masonry-engine";
import { Box as Box8 } from "@leagueplatform/genesis-core";
import { Video } from "@leagueplatform/genesis-core-alpha";
var MasonryVideoRenderer = ({
  url,
  thumbnail,
  altText,
  onPlay,
  onPause,
  onEnd
}) => {
  const invokeAction = useMasonryEngineActionEmitter17();
  const attachListenersOnReady = useCallback2(
    (player) => {
      player.on("play", (event) => {
        if (onPlay) {
          invokeAction(__spreadValues({
            event
          }, onPlay));
        }
      });
      player.on("pause", (event) => {
        if (onPause) {
          invokeAction(__spreadValues({
            event
          }, onPause));
        }
      });
      player.on("ended", (event) => {
        if (onEnd) {
          invokeAction(__spreadValues({
            event
          }, onEnd));
        }
      });
    },
    [invokeAction, onEnd, onPause, onPlay]
  );
  return /* @__PURE__ */ React37.createElement(Box8, { "aria-label": altText }, /* @__PURE__ */ React37.createElement(Video, { src: url, poster: thumbnail, onReady: attachListenersOnReady }));
};

// src/components/masonry-status-banner-renderer/masonry-status-banner-renderer.component.tsx
import React38, { useMemo as useMemo3 } from "react";
import {
  HtmlToReact as HtmlToReact3,
  Icon as Icon5,
  StackItem as StackItem10,
  StatusBanner,
  StatusBannerEmoji,
  TextAction as TextAction5
} from "@leagueplatform/genesis-core";
import {
  useMasonryEngineActionEmitter as useMasonryEngineActionEmitter18
} from "@leagueplatform/masonry-engine";
import { normalizeInternalUrl as normalizeInternalUrl2 } from "@leagueplatform/web-common";
var DefaultLeadingIcon = {
  type: "default",
  value: "",
  iconAltText: ""
};
var baseTitleStyles = { typography: "$subtitleOne" };
var deriveStatusBannerIcon = ({
  type,
  value,
  iconAltText
} = DefaultLeadingIcon) => {
  switch (type) {
    case "emoji":
      return /* @__PURE__ */ React38.createElement(
        StatusBannerEmoji,
        {
          "data-testid": "status-banner-icon",
          label: iconAltText,
          css: baseTitleStyles
        },
        value
      );
    case "url":
      return /* @__PURE__ */ React38.createElement(
        Icon5,
        {
          "data-testid": "status-banner-icon",
          icon: value,
          label: iconAltText
        }
      );
    case "default":
    default:
      return void 0;
  }
};
var TextActionStackItem = ({
  indicator,
  onClick,
  children
}) => /* @__PURE__ */ React38.createElement(StackItem10, { shrinkFactor: 0 }, /* @__PURE__ */ React38.createElement(TextAction5, { indicator, onClick }, children));
var MasonryStatusBannerRenderer = ({
  status = "info",
  heading,
  body,
  footerActionText,
  footerActionIndicator,
  headerActionIndicator,
  headerActionText,
  headingLevel = "3",
  leadingIcon,
  onDismiss,
  onFooterClick,
  onHeaderClick
}) => {
  var _a;
  const invokeAction = useMasonryEngineActionEmitter18();
  const onDismissClick = useMemo3(
    () => onDismiss ? (event) => invokeAction(__spreadValues({ event }, onDismiss)) : void 0,
    [invokeAction, onDismiss]
  );
  return /* @__PURE__ */ React38.createElement(
    StatusBanner,
    {
      status,
      title: heading,
      headingLevel,
      icon: deriveStatusBannerIcon(leadingIcon),
      iconLabel: leadingIcon == null ? void 0 : leadingIcon.iconAltText,
      onDismissClick,
      textAction: headerActionText && onHeaderClick ? /* @__PURE__ */ React38.createElement(
        TextActionStackItem,
        {
          indicator: headerActionIndicator,
          onClick: (event) => invokeAction(__spreadValues({ event }, onHeaderClick))
        },
        headerActionText
      ) : void 0,
      css: { justifyContent: "flex-start" }
    },
    body && /* @__PURE__ */ React38.createElement(HtmlToReact3, { htmlString: body, options: BodyTextHtmlTagOptions }),
    onFooterClick && footerActionText && /* @__PURE__ */ React38.createElement(
      TextAction5,
      {
        css: { alignSelf: "flex-start" },
        indicator: footerActionIndicator,
        href: normalizeInternalUrl2((_a = onFooterClick == null ? void 0 : onFooterClick.payload) == null ? void 0 : _a.url),
        onClick: (event) => invokeAction(__spreadValues({ event }, onFooterClick))
      },
      footerActionText
    )
  );
};

// src/components/masonry-forms/masonry-text-input-renderer/masonry-text-input-renderer.component.tsx
import React40, { useCallback as useCallback3, useMemo as useMemo4, useRef as useRef2 } from "react";
import {
  useMasonryEngineActionEmitter as useMasonryEngineActionEmitter19
} from "@leagueplatform/masonry-engine";
import {
  TextInput
} from "@leagueplatform/genesis-core";

// src/components/masonry-forms/masonry-form-field-renderer/masonry-form-field-wrapper.component.tsx
import React39 from "react";
import {
  Button as Button6,
  FormField,
  ParagraphText as ParagraphText17,
  Popover
} from "@leagueplatform/genesis-core";
var MasonryFormFieldWrapper = ({
  formFieldProperties: {
    formFieldId,
    inputStatus,
    statusMessage,
    label,
    hideLabel,
    tooltipIcon,
    tooltipContent,
    tooltipLabel,
    hint,
    showOptionalFlag
  },
  rootElementRef,
  children
}) => /* @__PURE__ */ React39.createElement(
  FormField,
  {
    ref: rootElementRef,
    id: formFieldId,
    label,
    name: formFieldId,
    hint,
    hideLabel,
    required: !showOptionalFlag,
    inputStatus,
    statusMessage,
    tooltip: tooltipContent && tooltipIcon && /* @__PURE__ */ React39.createElement(Popover.Root, null, /* @__PURE__ */ React39.createElement(Popover.Trigger, null, /* @__PURE__ */ React39.createElement(
      Button6,
      {
        icon: tooltipIcon,
        quiet: true,
        hideLabel: true,
        priority: "secondary",
        size: "small",
        css: { marginInlineStart: "0.5rem" }
      },
      tooltipLabel
    )), /* @__PURE__ */ React39.createElement(Popover.Content, { align: "start", side: "top", showCloseButton: false }, /* @__PURE__ */ React39.createElement(ParagraphText17, { size: "sm" }, tooltipContent)))
  },
  children
);

// src/components/masonry-forms/masonry-text-input-renderer/masonry-text-input-renderer.component.tsx
var MasonryTextInputRenderer = ({
  formFieldProperties,
  defaultValue,
  placeholder,
  value,
  clearable,
  leadingContent,
  trailingContent,
  leadingAddon,
  trailingAddon,
  disabled,
  readOnly,
  autoComplete,
  rootElementRef,
  min,
  max,
  minLength,
  maxLength
}) => {
  const { formFieldId, formFieldType } = formFieldProperties;
  const invokeAction = useMasonryEngineActionEmitter19();
  const clearInput = useRef2(null);
  const setNodeState = useCallback3(
    (newValue) => {
      invokeAction({
        type: "setNodeState",
        namespace: "default",
        payload: {
          state: { value: newValue }
        }
      });
    },
    [invokeAction]
  );
  const changeHandler = useCallback3(
    (event) => {
      setNodeState(event.target.value);
    },
    [setNodeState]
  );
  const blurHandler = useCallback3(
    (event) => {
      setNodeState(event.target.value);
    },
    [setNodeState]
  );
  const onClear = useCallback3(() => {
    setNodeState("");
  }, [setNodeState]);
  const leadingAddonProps = useMemo4(() => {
    if ((leadingAddon == null ? void 0 : leadingAddon.type) === "icon") {
      return {
        addOnStartIcon: leadingAddon.icon,
        addOnStartIconLabel: leadingAddon.value
      };
    }
    if ((leadingAddon == null ? void 0 : leadingAddon.type) === "text") {
      return { addOnStart: leadingAddon.value };
    }
    return void 0;
  }, [leadingAddon]);
  const trailingAddonProps = useMemo4(() => {
    if ((trailingAddon == null ? void 0 : trailingAddon.type) === "icon") {
      return {
        addOnEndIcon: trailingAddon.icon,
        addOnEndIconLabel: trailingAddon.value
      };
    }
    if ((trailingAddon == null ? void 0 : trailingAddon.type) === "text") {
      return { addOnEnd: trailingAddon.value };
    }
    return void 0;
  }, [trailingAddon]);
  return /* @__PURE__ */ React40.createElement(
    MasonryFormFieldWrapper,
    {
      rootElementRef,
      formFieldProperties
    },
    /* @__PURE__ */ React40.createElement(
      TextInput,
      __spreadProps(__spreadValues(__spreadValues({
        id: formFieldId,
        type: formFieldType,
        value,
        defaultValue,
        placeholder,
        onChange: changeHandler,
        onBlur: blurHandler,
        clearable,
        onClear,
        disabled,
        readOnly,
        autoComplete,
        leadingContent,
        trailingContent,
        min,
        max,
        minLength,
        maxLength
      }, leadingAddonProps), trailingAddonProps), {
        ref: clearInput
      })
    )
  );
};

// src/components/masonry-forms/masonry-select-input-renderer/masonry-select-input-renderer.component.tsx
import React41, { useCallback as useCallback4, useMemo as useMemo5 } from "react";
import {
  useMasonryEngineActionEmitter as useMasonryEngineActionEmitter20
} from "@leagueplatform/masonry-engine";
import { Select } from "@leagueplatform/genesis-core";
var MasonrySelectInputRenderer = ({
  formFieldProperties,
  defaultValue,
  value,
  placeholder,
  ariaDisabled,
  options,
  disabled,
  rootElementRef
}) => {
  const { formFieldId, hint: fieldHint } = formFieldProperties;
  const computedValue = useMemo5(() => {
    if (value == null ? void 0 : value.length)
      return value;
    if (defaultValue == null ? void 0 : defaultValue.length)
      return defaultValue;
    return void 0;
  }, [defaultValue, value]);
  const invokeAction = useMasonryEngineActionEmitter20();
  const setNodeState = useCallback4(
    (event) => {
      const actionParams = {
        event,
        namespace: "default",
        payload: { state: { value: event.target.value } }
      };
      return invokeAction(__spreadValues({ type: "setNodeState" }, actionParams));
    },
    [invokeAction]
  );
  const selectOptions = useMemo5(
    () => options.map(
      ({
        label,
        value: optValue,
        disabled: optDisabled,
        options: groupOptions
      }, index) => {
        if (groupOptions) {
          return {
            key: `${formFieldId}-${index}`,
            label,
            disabled: optDisabled,
            options: groupOptions.map((childOpt, childIndex) => ({
              key: `${formFieldId}-${index}${childIndex}`,
              value: childOpt.value,
              disabled: childOpt.disabled,
              label: childOpt.label
            }))
          };
        }
        return {
          key: `${formFieldId}-${index}`,
          label,
          value: optValue,
          disabled: optDisabled
        };
      }
    ),
    [formFieldId, options]
  );
  return /* @__PURE__ */ React41.createElement(
    MasonryFormFieldWrapper,
    {
      formFieldProperties,
      hint: fieldHint,
      rootElementRef
    },
    /* @__PURE__ */ React41.createElement(
      Select,
      {
        "aria-disabled": ariaDisabled,
        placeholder,
        name: formFieldId,
        value: computedValue,
        disabled,
        options: selectOptions,
        defaultValue,
        onChange: setNodeState
      }
    )
  );
};

// src/components/masonry-content-block-renderer/masonry-content-block-renderer.component.tsx
import React42 from "react";
import {
  Box as Box9,
  HeadingText as HeadingText13,
  ParagraphText as ParagraphText18
} from "@leagueplatform/genesis-core";
var MasonryContentBlockRenderer = ({
  body,
  bodySize = "base",
  bodyEmphasis = "base",
  heading,
  headingEmphasis = "base",
  headingLevel = "3",
  headingSize = "md",
  rootElementRef
}) => /* @__PURE__ */ React42.createElement(Box9, { ref: rootElementRef }, heading && /* @__PURE__ */ React42.createElement(
  HeadingText13,
  {
    level: headingLevel,
    size: headingSize,
    emphasis: headingEmphasis
  },
  heading
), /* @__PURE__ */ React42.createElement(
  ParagraphText18,
  {
    size: bodySize,
    emphasis: bodyEmphasis,
    htmlStringOptions: BodyTextHtmlTagOptions
  },
  body
));

// src/components/masonry-sticky-layout-renderer/masonry-sticky-layout-renderer.component.tsx
import React43, { useLayoutEffect as useLayoutEffect2, useRef as useRef3, useState as useState3 } from "react";
import {
  StackLayout as StackLayout19,
  StackItem as StackItem11,
  spacingTokenMap as spacingTokenMap5,
  useMediaQuery as useMediaQuery4,
  queryHelpers as queryHelpers4,
  Box as Box10
} from "@leagueplatform/genesis-core";
var MasonryStickyLayoutRenderer = ({
  items,
  headerItems,
  footerItems,
  spacing = "one"
}) => {
  const isMobileLandscape = useMediaQuery4(queryHelpers4.only("mobileLandscape"));
  const headerRef = useRef3(null);
  const footerRef = useRef3(null);
  const [headerHeight, setHeaderHeight] = useState3(0);
  const [footerHeight, setFooterHeight] = useState3(0);
  useLayoutEffect2(() => {
    if (headerRef.current) {
      setHeaderHeight(headerRef.current.offsetHeight);
    }
    if (footerRef.current) {
      setFooterHeight(footerRef.current.offsetHeight);
    }
  }, []);
  if (!items)
    return null;
  const layoutSpacing = spacingTokenMap5[spacing] || "$one";
  return /* @__PURE__ */ React43.createElement(
    StackLayout19,
    {
      spacing: isMobileLandscape ? layoutSpacing : "$none",
      horizontalAlignment: "stretch",
      orientation: "vertical",
      css: {
        paddingTop: isMobileLandscape ? "$none" : `calc(${headerHeight}px + ${layoutSpacing})`,
        paddingBottom: isMobileLandscape ? "$none" : `calc(${footerHeight}px + ${layoutSpacing})`
      }
    },
    headerItems && /* @__PURE__ */ React43.createElement(
      Box10,
      {
        css: {
          position: isMobileLandscape ? "static" : "absolute",
          top: 0,
          left: 0,
          zIndex: "$default",
          width: "100%"
        }
      },
      /* @__PURE__ */ React43.createElement(
        StackLayout19,
        {
          ref: headerRef,
          horizontalAlignment: "stretch",
          orientation: "vertical"
        },
        React43.Children.map(
          headerItems,
          (item) => item && /* @__PURE__ */ React43.createElement(StackItem11, null, item)
        )
      )
    ),
    items && /* @__PURE__ */ React43.createElement(
      StackLayout19,
      {
        horizontalAlignment: "stretch",
        orientation: "vertical",
        css: {
          overflowY: isMobileLandscape ? "show" : "auto",
          height: "fit-content"
        }
      },
      React43.Children.map(
        items,
        (item) => item && /* @__PURE__ */ React43.createElement(StackItem11, null, item)
      )
    ),
    footerItems && /* @__PURE__ */ React43.createElement(
      Box10,
      {
        css: {
          position: isMobileLandscape ? "static" : "absolute",
          bottom: 0,
          left: 0,
          width: "100%"
        }
      },
      /* @__PURE__ */ React43.createElement(
        StackLayout19,
        {
          ref: footerRef,
          horizontalAlignment: "stretch",
          orientation: "vertical"
        },
        React43.Children.map(
          footerItems,
          (item) => item && /* @__PURE__ */ React43.createElement(StackItem11, null, item)
        )
      )
    )
  );
};

// src/components/masonry-forms/masonry-checkbox-renderer/masonry-checkbox-renderer.component.tsx
import React45, {
  useCallback as useCallback5,
  useMemo as useMemo6
} from "react";
import {
  useMasonryEngineActionEmitter as useMasonryEngineActionEmitter21
} from "@leagueplatform/masonry-engine";
import { Checkbox } from "@leagueplatform/genesis-core";

// src/components/masonry-forms/masonry-fieldset-wrapper/masonry-fieldset-wrapper.component.tsx
import React44 from "react";
import {
  Button as Button7,
  Fieldset,
  ParagraphText as ParagraphText19,
  Popover as Popover2
} from "@leagueplatform/genesis-core";
var MasonryFieldsetWrapper = ({
  rootElementRef,
  formFieldProperties,
  disabled,
  children,
  css,
  onChange
}) => {
  const {
    formFieldId,
    inputStatus,
    statusMessage,
    label,
    hideLabel,
    tooltipIcon,
    tooltipContent,
    tooltipLabel,
    hint,
    showOptionalFlag
  } = formFieldProperties;
  return /* @__PURE__ */ React44.createElement(
    Fieldset,
    {
      ref: rootElementRef,
      id: formFieldId,
      name: formFieldId,
      legend: label,
      hideLegend: hideLabel,
      hint,
      required: !showOptionalFlag,
      inputStatus,
      statusMessage,
      disabled,
      onChange,
      css,
      tooltip: tooltipContent && tooltipIcon && /* @__PURE__ */ React44.createElement(Popover2.Root, null, /* @__PURE__ */ React44.createElement(Popover2.Trigger, null, /* @__PURE__ */ React44.createElement(
        Button7,
        {
          icon: tooltipIcon,
          quiet: true,
          hideLabel: true,
          priority: "secondary",
          size: "small",
          css: { marginInlineStart: "0.5rem" }
        },
        tooltipLabel
      )), /* @__PURE__ */ React44.createElement(Popover2.Content, { align: "start", side: "top", showCloseButton: false }, /* @__PURE__ */ React44.createElement(ParagraphText19, { size: "sm" }, tooltipContent)))
    },
    /* @__PURE__ */ React44.createElement("div", { className: "GDS-input-wrapper" }, children)
  );
};

// src/components/masonry-forms/masonry-checkbox-renderer/masonry-checkbox-renderer.component.tsx
var MasonryCheckboxRenderer = ({
  formFieldProperties,
  defaultValue,
  value: initialValue,
  layout,
  options,
  disabled,
  rootElementRef,
  onChange
}) => {
  const { formFieldId, hint: fieldHint } = formFieldProperties;
  const computedValue = useMemo6(() => {
    if (initialValue == null ? void 0 : initialValue.length)
      return initialValue;
    if (defaultValue == null ? void 0 : defaultValue.length)
      return defaultValue;
    return [];
  }, [defaultValue, initialValue]);
  const exclusiveValues = options.filter((option) => option.exclusive).map((option) => option.value);
  const orientation = layout === "inline" ? "row" : "column";
  const invokeAction = useMasonryEngineActionEmitter21();
  const setNodeState = useCallback5(
    (event, nextValue) => __async(void 0, null, function* () {
      const actionParams = {
        event,
        namespace: "default",
        payload: {
          state: {
            value: nextValue
          }
        }
      };
      yield invokeAction(__spreadValues({ type: "setNodeState" }, actionParams));
      if (onChange) {
        invokeAction(__spreadProps(__spreadValues({}, onChange), { event }));
      }
    }),
    [invokeAction, onChange]
  );
  const changeHandler = useCallback5(
    (event) => {
      const { value: targetValue, checked, dataset } = event.target;
      if (!checked) {
        const nextValue2 = computedValue.filter(
          (checkedValue) => checkedValue !== targetValue
        );
        return setNodeState(event, nextValue2);
      }
      if (dataset.exclusive === "true") {
        return setNodeState(event, [targetValue]);
      }
      const nextValue = computedValue.concat(targetValue).filter((selectedValue) => !exclusiveValues.includes(selectedValue));
      return setNodeState(event, nextValue);
    },
    [computedValue, exclusiveValues, setNodeState]
  );
  const Wrapper = useMemo6(
    () => (options == null ? void 0 : options.length) > 1 ? MasonryFieldsetWrapper : MasonryFormFieldWrapper,
    [options == null ? void 0 : options.length]
  );
  return /* @__PURE__ */ React45.createElement(
    Wrapper,
    {
      formFieldProperties,
      hint: fieldHint,
      rootElementRef,
      disabled,
      css: {
        ".GDS-input-wrapper": { display: "flex", flexDirection: orientation }
      }
    },
    options == null ? void 0 : options.map((option, optionIndex) => {
      const { label, value, exclusive, hint } = option;
      const optionId = `${formFieldId}-${optionIndex}`;
      return /* @__PURE__ */ React45.createElement(
        Checkbox,
        {
          key: optionId,
          id: optionId,
          name: formFieldId,
          label,
          value,
          hint,
          disabled: option.disabled,
          checked: computedValue == null ? void 0 : computedValue.includes(value == null ? void 0 : value.toString()),
          onChange: changeHandler,
          "data-exclusive": Boolean(exclusive)
        }
      );
    })
  );
};

// src/components/masonry-forms/masonry-radio-renderer/masonry-radio-renderer.component.tsx
import React46, { useCallback as useCallback6 } from "react";
import {
  useMasonryEngineActionEmitter as useMasonryEngineActionEmitter22
} from "@leagueplatform/masonry-engine";
import { Radio } from "@leagueplatform/genesis-core";
var MasonryRadioRenderer = ({
  formFieldProperties,
  value: initialValue,
  defaultValue,
  layout,
  options,
  disabled,
  rootElementRef,
  onChange
}) => {
  const { formFieldId, hint: fieldHint } = formFieldProperties;
  const value = initialValue != null ? initialValue : defaultValue;
  const orientation = layout === "inline" ? "row" : "column";
  const invokeAction = useMasonryEngineActionEmitter22();
  const setNodeState = useCallback6(
    (event) => __async(void 0, null, function* () {
      const { target } = event;
      yield invokeAction({
        event,
        type: "setNodeState",
        namespace: "default",
        payload: { state: { value: target.value } }
      });
      if (onChange) {
        invokeAction(onChange);
      }
    }),
    [invokeAction, onChange]
  );
  const Wrapper = (options == null ? void 0 : options.length) > 1 ? MasonryFieldsetWrapper : MasonryFormFieldWrapper;
  return /* @__PURE__ */ React46.createElement(
    Wrapper,
    {
      formFieldProperties,
      hint: fieldHint,
      rootElementRef,
      disabled,
      css: {
        ".GDS-input-wrapper": { display: "flex", flexDirection: orientation }
      }
    },
    options == null ? void 0 : options.map((option, optionIndex) => {
      const { label, value: optionValue, hint } = option;
      const optionId = `${formFieldId}-${optionIndex}`;
      return /* @__PURE__ */ React46.createElement(
        Radio,
        {
          key: optionId,
          id: optionId,
          name: formFieldId,
          label,
          value: optionValue,
          hint,
          disabled: option.disabled,
          checked: value == optionValue,
          onChange: setNodeState
        }
      );
    })
  );
};

// src/components/masonry-basic-table-renderer/masonry-basic-table-renderer.component.tsx
import * as React47 from "react";
import { Table } from "@leagueplatform/genesis-core-alpha";
import { HtmlToReact as HtmlToReact4 } from "@leagueplatform/genesis-core";
import { useUniqueId } from "@leagueplatform/web-common";
var MasonryBasicTableRenderer = ({
  tableName,
  hasBorder,
  headerBackgroundColor = "secondary",
  headers,
  rows
}) => {
  const uniqueId4 = useUniqueId();
  if (!(headers == null ? void 0 : headers.length) || !(rows == null ? void 0 : rows.length))
    return null;
  return /* @__PURE__ */ React47.createElement(Table, { tableName, border: hasBorder, isResponsive: true }, /* @__PURE__ */ React47.createElement(Table.Head, null, /* @__PURE__ */ React47.createElement(Table.Row, null, headers.map((header) => /* @__PURE__ */ React47.createElement(
    Table.Header,
    {
      key: header.id,
      label: header.name,
      backgroundColor: headerBackgroundColor
    }
  )))), /* @__PURE__ */ React47.createElement(Table.Body, null, rows.map((row, rowIndex) => /* @__PURE__ */ React47.createElement(
    Table.Row,
    {
      key: `${uniqueId4}-${rowIndex}`
    },
    row.row.map((cell, cellIndex) => (
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ React47.createElement(Table.Cell, { key: `${uniqueId4}-${rowIndex}-${cellIndex}` }, /* @__PURE__ */ React47.createElement(HtmlToReact4, { htmlString: cell }))
    ))
  ))));
};

// src/components/masonry-composable-card-renderer/masonry-composable-card-renderer.component.tsx
import React48 from "react";
import {
  ComposableCard,
  useClickableCard as useClickableCard10
} from "@leagueplatform/genesis-core";
import {
  useMasonryEngineActionEmitter as useMasonryEngineActionEmitter23
} from "@leagueplatform/masonry-engine";
import { Link as Link2 } from "@leagueplatform/routing";
import { isExternalUrl } from "@leagueplatform/web-common";
var getActionUrl = (action) => {
  if (action && isLinkAction(action)) {
    return action.payload.url;
  }
  return void 0;
};
var MasonryComposableCardRenderer = ({
  backgroundColor = "primary",
  dismissButtonLabel,
  media,
  body,
  cta,
  onDismiss,
  onFirstButtonClick,
  onSecondButtonClick,
  onCardClick,
  contentSlot
}) => {
  const invokeAction = useMasonryEngineActionEmitter23();
  const _a = body || {}, { backgroundImage, backgroundOverlay } = _a, bodyProps = __objRest(_a, ["backgroundImage", "backgroundOverlay"]);
  const { position, firstCta, secondCta } = cta || {};
  const { onCardMouseDown, onCardMouseUp, primaryActionRef, clickAreaRef } = useClickableCard10();
  const bodyHref = getActionUrl(onCardClick);
  const firstButtonHref = getActionUrl(onFirstButtonClick) || "";
  const secondButtonHref = getActionUrl(onSecondButtonClick) || "";
  return /* @__PURE__ */ React48.createElement(
    ComposableCard.Root,
    __spreadValues(__spreadValues(__spreadValues({
      backgroundColor,
      backgroundImage,
      backgroundOverlay,
      dismissButtonLabel
    }, onDismiss && {
      onDismiss: (event) => {
        if (onDismiss) {
          invokeAction(__spreadValues({
            event
          }, onDismiss));
        }
      }
    }), media), onCardClick && {
      onCardMouseDown,
      onCardMouseUp,
      ref: clickAreaRef
    }),
    body && /* @__PURE__ */ React48.createElement(
      ComposableCard.Body,
      __spreadValues(__spreadValues({}, bodyProps), onCardClick && {
        ref: primaryActionRef,
        href: bodyHref,
        linkAs: !isExternalUrl(bodyHref) ? Link2 : void 0,
        to: !isExternalUrl(bodyHref) ? bodyHref : void 0,
        onClick: (event) => {
          if (onCardClick) {
            invokeAction(__spreadValues({
              event
            }, onCardClick));
          }
        }
      })
    ),
    contentSlot && /* @__PURE__ */ React48.createElement(ComposableCard.Content, null, contentSlot),
    cta && /* @__PURE__ */ React48.createElement(
      ComposableCard.CTASection,
      {
        position,
        firstCta: __spreadValues({
          onClick: (event) => {
            if (onFirstButtonClick) {
              invokeAction(__spreadValues({
                event
              }, onFirstButtonClick));
            }
          },
          href: firstButtonHref,
          as: !isExternalUrl(firstButtonHref) ? Link2 : void 0,
          to: !isExternalUrl(firstButtonHref) ? firstButtonHref : void 0
        }, firstCta),
        secondCta: __spreadValues({
          onClick: (event) => {
            if (onSecondButtonClick) {
              invokeAction(__spreadValues({
                event
              }, onSecondButtonClick));
            }
          },
          href: secondButtonHref,
          as: !isExternalUrl(secondButtonHref) ? Link2 : void 0,
          to: !isExternalUrl(secondButtonHref) ? secondButtonHref : void 0
        }, secondCta)
      }
    )
  );
};

// src/components/masonry-accordion-item-renderer/masonry-accordion-item-renderer.component.tsx
import * as React49 from "react";
import {
  useMasonryEngineActionEmitter as useMasonryEngineActionEmitter24
} from "@leagueplatform/masonry-engine";
import { Accordion } from "@leagueplatform/genesis-core-alpha";
var NODE_TYPE_ACCORDION_ITEM = "accordionItem";
var MasonryAccordionItemRenderer = ({
  isExpanded,
  heading,
  headingLevel,
  onToggle,
  items
}) => {
  const invokeAction = useMasonryEngineActionEmitter24();
  const isExpandedRef = React49.useRef(isExpanded);
  isExpandedRef.current = isExpanded;
  const clickHandler = React49.useCallback(() => {
    invokeAction({
      type: "setNodeState",
      namespace: "default",
      payload: {
        state: {
          isExpanded: !isExpandedRef.current
        }
      }
    });
    if (onToggle) {
      invokeAction(__spreadValues(__spreadValues({}, onToggle), (onToggle == null ? void 0 : onToggle.analytics) ? {
        analytics: __spreadProps(__spreadValues({}, onToggle.analytics), {
          isExpanded: !isExpandedRef.current
        })
      } : {}));
    }
  }, [onToggle, invokeAction]);
  if (!items || !items.length)
    return null;
  return /* @__PURE__ */ React49.createElement(
    Accordion,
    {
      onClick: clickHandler,
      isExpanded,
      heading,
      headingLevel
    },
    items
  );
};

// src/components/masonry-segment-control-renderer/masonry-segment-control-renderer.component.tsx
import * as React50 from "react";
import {
  useMasonryEngineActionEmitter as useMasonryEngineActionEmitter25
} from "@leagueplatform/masonry-engine";
import {
  SegmentedControl,
  SegmentedControlRoot
} from "@leagueplatform/genesis-core-alpha";
import { Box as Box11, Tabs as Tabs2 } from "@leagueplatform/genesis-core";
var NODE_TYPE_SEGMENT_CONTROL = "segmentedControl";
var findIndexById = (id, data) => data.findIndex((item) => item.id === id);
var MasonrySegmentControlRenderer = ({
  segmentedControlName,
  defaultSelectedControlId,
  controlList,
  items,
  onClick
}) => {
  const [viewSelection, setViewSelection] = React50.useState(0);
  const invokeAction = useMasonryEngineActionEmitter25();
  const clickHandler = React50.useCallback(
    (event) => {
      var _a;
      const value = (_a = event.currentTarget.dataset) == null ? void 0 : _a.segment;
      const index = findIndexById(value, controlList);
      setViewSelection(index);
      if (onClick) {
        invokeAction(__spreadProps(__spreadValues({}, onClick), {
          payload: __spreadProps(__spreadValues({}, onClick.payload), {
            refreshParams: {
              index
            }
          })
        }));
      }
    },
    [controlList, invokeAction, onClick]
  );
  React50.useEffect(() => {
    const selectedIndex = findIndexById(defaultSelectedControlId, controlList);
    if (selectedIndex !== -1)
      setViewSelection(selectedIndex);
  }, [controlList, defaultSelectedControlId]);
  if (!items || !items.length)
    return null;
  return /* @__PURE__ */ React50.createElement(Box11, { css: { marginBottom: "$oneAndHalf" } }, /* @__PURE__ */ React50.createElement(
    SegmentedControlRoot,
    {
      segmentedControlName,
      defaultSelectedControlId
    },
    /* @__PURE__ */ React50.createElement(SegmentedControl.List, { "aria-label": segmentedControlName }, controlList.map((item) => /* @__PURE__ */ React50.createElement(
      SegmentedControl.Button,
      {
        key: `${item.id}-panel`,
        value: item.id,
        "aria-label": item.title,
        onClick: clickHandler
      },
      item.title
    ))),
    controlList.map((item) => /* @__PURE__ */ React50.createElement(Tabs2.TabPanel, { key: `${item.id}-list`, value: item.id }, items[viewSelection]))
  ));
};

// src/components/masonry-forms/masonry-form-renderer/masonry-form-renderer.component.tsx
import React51 from "react";
import { styled as styled7 } from "@leagueplatform/genesis-core";
var StyledForm = styled7("form", {
  display: "flex",
  flexDirection: "column",
  gap: "2rem",
  maxWidth: "800px"
});
var MasonryFormRenderer = ({ layout }) => {
  const handleFormSubmit = (event) => {
    event.preventDefault();
  };
  return /* @__PURE__ */ React51.createElement(StyledForm, { onSubmit: handleFormSubmit }, layout);
};
export {
  BadgeList,
  DismissButton,
  MasonryAccordionItemRenderer,
  MasonryBasicTableRenderer,
  MasonryButtonRenderer,
  MasonryCTACardRenderer,
  MasonryCarouselRenderer,
  MasonryCheckboxRenderer,
  MasonryColumnLayoutRenderer,
  MasonryComposableCardRenderer,
  MasonryContentBlockRenderer,
  MasonryDividerRenderer,
  MasonryExtraSmallCardRenderer,
  MasonryFormRenderer,
  MasonryGridLayoutRenderer,
  MasonryHeroBannerRenderer,
  MasonryHorizontalLayoutRenderer,
  MasonryImageBannerRenderer,
  MasonryLargeCardRenderer,
  MasonryLoaderRenderer,
  MasonryMetricCardRenderer,
  MasonryMicroCardRenderer,
  MasonryNotificationBannerRenderer,
  MasonryNotificationCardRenderer,
  MasonryProgressBarCardRenderer,
  MasonryProgressRingCardRenderer,
  MasonryRadioRenderer,
  MasonrySectionHeaderRenderer,
  MasonrySegmentControlRenderer,
  MasonrySelectInputRenderer,
  MasonrySidebarLayoutRenderer,
  MasonrySmallCardRenderer,
  MasonryStatusBannerRenderer,
  MasonryStickyLayoutRenderer,
  MasonryTabsRenderer,
  MasonryTextActionRenderer,
  MasonryTextInputRenderer,
  MasonryVerticalLayoutRenderer,
  MasonryVideoRenderer,
  NODE_TYPE_ACCORDION_ITEM,
  NODE_TYPE_SEGMENT_CONTROL,
  getTextActionIndicatorIconToken,
  isLinkAction,
  useGetTraitsForMedia
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/masonry-renderers'] = window.leagueSDKsPresent['@leagueplatform/masonry-renderers'] || [];
    window.leagueSDKsPresent['@leagueplatform/masonry-renderers'].push('2.23.5');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/masonry-renderers'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/masonry-renderers module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map